webpackJsonp([48],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3BBE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6L8A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9F4c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const storeID = 1
const appVersion = 1.1





// function _appVersion(){
// 	return appVersion;
// }

// function _storeid(){
// 	return storeID;
// }



module.exports = {
  appversion: appVersion,
  storeID: storeID
}

/***/ }),

/***/ "ENQs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FMur":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kf48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const urlConfig = {
  development: {
    plapi: "http://php-api.test1.fangzhibao.com/api",
    extapi: "http://extapi.test1.fangzhibao.com/v1",
    productionDetailUrl: "http://detail.test1.fangzhibao.com",
    main: "http://www.test1.fangzhibao.com",
    newMain: "http://seller.test1.fangzhibao.com",
    search: "http://search.test1.fangzhibao.com",
    member: "http://member.test1.fangzhibao.com",
    mainApi: "http://nodejs-api.test1.fangzhibao.com/v1",
    login: "http://login.test1.fangzhibao.com",
    user: "http://sc.test1.fangzhibao.com",
    erp: "http://fzb-erp.test1.fangzhibao.cn",
    qiniu: "http://qiniutest.fangzhibao.com",
    pages: "http://pages.test1.fangzhibao.com"
  },
  production: {
    plapi: "https://api-pl-mobile.fangzhibao.com/api",
    extapi: "https://extapi.fangzhibao.com/v1",
    productionDetailUrl: "https://detail.fangzhibao.com",
    main: "https://www.fangzhibao.com",
    newMain: "https://seller.fangzhibao.com",
    search: "https://search.fangzhibao.com",
    member: "https://member.fangzhibao.com",
    mainApi: "https://api.fangzhibao.com/v1",
    login: "https://login.fangzhibao.com",
    user: "https://sc.fangzhibao.com",
    erp: "https://erp.fangzhibao.cn",
    qiniu: "https://qiniu.fangzhibao.com",
    pages: "https://pages.fangzhibao.com"
  },
  // test1: {
  //   plapi: "http://php-api.test1.fangzhibao.com/api",
  //   extapi: "http://extapi.test1.fangzhibao.com/v1",
  //   productionDetailUrl: "http://detail.test1.fangzhibao.com",
  //   main: "http://www.test1.fangzhibao.com",
  //   newMain: "http://seller.test1.fangzhibao.com",
  //   search: "http://search.test1.fangzhibao.com",
  //   member: "http://member.test1.fangzhibao.com",
  //   mainApi: "http://nodejs-api.test1.fangzhibao.com/v1",
  //   login: "http://login.test1.fangzhibao.com",
  //   user: "http://sc.test1.fangzhibao.com",
  //   erp: "http://fzb-erp.test1.fangzhibao.cn",
  //   qiniu: "http://qiniutest.fangzhibao.com",
  //   pages: "http://pages.test1.fangzhibao.com"
  // },
  test2: {
    plapi: "https://php-api.test2.fangzhibao.com/api",
    extapi: "https://extapi.test2.fangzhibao.com/v1",
    productionDetailUrl: "https://detail.test2.fangzhibao.com",
    main: "https://www.test2.fangzhibao.com",
    search: "https://search.test2.fangzhibao.com",
    member: "https://member.test2.fangzhibao.com",
    mainApi: "https://nodejs-api.test2.fangzhibao.com/v1",
    login: "https://login.test2.fangzhibao.com",
    user: "https://sc.test2.fangzhibao.com",
    erp: "https://fzb-erp.test2.fangzhibao.cn",
    qiniu: "https://qiniutest.fangzhibao.com"
  },
  test3: {
    plapi: "http://php-api.test3.fangzhibao.com/api",
    extapi: "http://extapi.test3.fangzhibao.com/v1",
    productionDetailUrl: "http://detail.test3.fangzhibao.com",
    main: "http://www.test3.fangzhibao.com",
    search: "http://search.test3.fangzhibao.com",
    member: "http://member.test3.fangzhibao.com",
    mainApi: "http://nodejs-api.test3.fangzhibao.com/v1",
    login: "http://login.test3.fangzhibao.com",
    user: "http://sc.test3.fangzhibao.com",
    erp: "http://fzb-erp.test3.fangzhibao.cn",
    qiniu: "http://qiniutest.fangzhibao.com"
  },
  stage: {
    plapi: "http://php-api.stage.fangzhibao.com/api",
    extapi: "http://extapi.stage.fangzhibao.com/v1",
    productionDetailUrl: "http://detail.stage.fangzhibao.com",
    main: "http://www.stage.fangzhibao.com",
    search: "http://search.stage.fangzhibao.com",
    member: "http://member.stage.fangzhibao.com",
    mainApi: "http://node.stage-api.fangzhibao.com/v1",
    login: "http://login.stage.fangzhibao.com",
    user: "http://sc.stage.fangzhibao.com",
    erp: "http://fzb-erp.stage.fangzhibao.cn",
    qiniu: "http://qiniutest.fangzhibao.com"
  },
  test1: {
    plapi: "http://php-api.test1.fangzhibao.com/api",
    extapi: "http://extapi.test1.fangzhibao.com/v1",
    productionDetailUrl: "http://detail.test1.fangzhibao.com",
    main: "http://www.test1.fangzhibao.com",
    newMain: "http://seller.test1.fangzhibao.com",
    search: "http://search.test1.fangzhibao.com",
    member: "http://member.test1.fangzhibao.com",
    mainApi: "http://nodejs-api.test1.fangzhibao.com/v1",
    login: "http://login.test1.fangzhibao.com",
    user: "http://sc.test1.fangzhibao.com",
    erp: "http://fzb-erp.test1.fangzhibao.cn",
    qiniu: "http://qiniutest.fangzhibao.com",
    pages: "http://pages.test1.fangzhibao.com"
  }
};
/* unused harmony export urlConfig */


const APP_ENV = "production";
/* unused harmony export APP_ENV */


const CurrentEnvPrefix = urlConfig[APP_ENV];
/* harmony export (immutable) */ __webpack_exports__["a"] = CurrentEnvPrefix;



/***/ }),

/***/ "N1Qb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-cookie/src/vue-cookie.js
var vue_cookie = __webpack_require__("K/Lq");
var vue_cookie_default = /*#__PURE__*/__webpack_require__.n(vue_cookie);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//


/* harmony default export */ var App = ({
  metaInfo: function metaInfo() {
    var color_type = vue_cookie_default.a.get('color_type') ? vue_cookie_default.a.get('color_type') : 1;
    if (color_type == '4') {
      return {
        link: [{
          rel: "icon",
          href: "/static/icon/zl_favicon.png"
        }, {
          rel: 'stylesheet',
          href: "/static/css/childmain.css"
        }]
      };
    } else if (color_type == '2') {
      return {
        link: [{
          rel: "icon",
          href: "/static/icon/gz_favicon.png"
        }, {
          rel: 'stylesheet',
          href: "/static/css/gzmain.css"
        }]
      };
    } else if (color_type == '3') {
      return {
        link: [{
          rel: "icon",
          href: "/static/icon/dmnz_favicon.png"
        }, {
          rel: 'stylesheet',
          href: "/static/css/dmnzmain.css"
        }]
      };
    } else if (color_type == '6') {
      return {
        link: [{
          rel: "icon",
          href: "/static/icon/xt_favicon.png"
        }, {
          rel: 'stylesheet',
          href: "/static/css/xtmain.css"
        }]
      };
    }
    return {
      link: [{
        rel: "icon",
        href: "/static/icon/cs_favicon.png"
      }, {
        rel: 'stylesheet',
        href: "/static/css/main.css"
      }]
    };
  },

  name: 'App',
  mounted: function mounted() {
    var _this = this;

    this.Common.addSPM(this.$route.query.spm);
    this.$Api.get({ api: this.Common.getSourec().plapi + '/setting/fragment_setting_list' }).then(function (response) {
      if (response.data.ResponseStatus == 0) {
        var data = response.data.datas;
        _this.Common.getSourec().site = data;
      } else {
        _this.$dialog.toast({ mes: response.data.ResponseMsg });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-886d7f88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("RbWE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["default"].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: "/newgoods",
  name: "newgoods",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Vzjr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/hotsearch",
  name: "hotsearch",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xJ1D")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/brand",
  name: "brand",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OKst")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/navigation",
  name: "navigation",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2bYq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/wetchat",
  name: "wetchat",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1WQx")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/seasongoods",
  name: "seasongoods",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4XIM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/newtowel",
  name: "newtowel",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("b1/P")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/winprize",
  name: "winprize",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("y4mk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/goodsupplier",
  name: "goodsupplier",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lnXN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/topsupplier",
  name: "topsupplier",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("i6fH")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/topstore",
  name: "topstore",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DZOF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/purchase", //采购节
  name: "purchase",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ejLL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/tianmao", //天猫二手店
  name: "tianmao",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4nul")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/tianmao_detail", //天猫二手店
  name: "tianmao_detail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DsEA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/yiqing", //疫情专题
  name: "yiqing",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MBAr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/repeatwork", //企业复工
  name: "repeatwork",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PvdM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/findgoods", //发现好货
  name: "findgoods",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wQdD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/hotstore", //人气商家
  name: "hotstore",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AxJ8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/jiafangcheng", //家纺城专题
  name: "jiafangcheng",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dQEI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/zhounian", //4周年
  name: "zhounian",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M/1b")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/channel", //文章频道
  name: "channel",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tydn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/articlelist", //文章列表
  name: "articlelist",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Pf+l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/articledetail", //文章详情
  name: "articledetail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MvSn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/zjfrecord", //找家纺大事记
  name: "zjfrecord",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iQo0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/videolist", //视频列表
  name: "videolist",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1WAS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/videodetail", //视频详情
  name: "videodetail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("K0Gj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/xuanpin", //直播选品
  name: "xuanpin",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("e2Au")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/mayi", //蚂蚁仓
  name: "mayi",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("anH9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  //收藏夹
  path: "/favorites",
  name: "favorites",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2E/6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "*", //
  name: "unfind",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7Rwl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/zhaohuo", //找货助手
  name: "zhaohuo",
  // component: resolve => require(["@/components/special/zhaohuo"], resolve)
  redirect: function redirect(to) {
    window.location.href = 'https://www.fangzhibao.com';
  }
}, {
  path: "/landingPage", //找货助手
  name: "landingPage",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("38SY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/antbarn", //蚂蚁仓频道招商
  name: "antbarn",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3Rbi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/basketball", //篮球赛
  name: "basketball",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("I8B0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/basketballstyle", //篮球赛
  name: "basketballstyle",
  component: function component(resolve) {
    return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wLp9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/springclose", //春节不打烊
  name: "springclose",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XSaj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/newyear", //新年活动
  name: "newyear",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("t609")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/feedback", // 投诉
  name: "feedback",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8xe4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/montage", // 红馆拼接广告
  name: "montage",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zidh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/subsidy", // 男装百亿补贴
  name: "subsidy",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QXnv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/subsidy_zl", // 童装百亿补贴
  name: "subsidy_zl",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MweT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/subsidy_csdmnvz", // 女装百亿补贴
  name: "subsidy_csdmnvz",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2NQ4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/tongzhuang", // 热卖童装
  name: "tongzhuang",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("O9Rj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/touristseason", // 热卖童装
  name: "touristseason",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UPqX")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/transportnew", // 运费测算
  name: "transportnew",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yhqV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/onlineretailertool", // 新页面onlineretailertool
  name: "onlineretailertool",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("d3ql")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/** 一个只允许访问找货助手的站点，且剔除品牌信息 */
if (location.host === 'zhaohuo.mqgou.com') {
  try {
    document.title = '找货助手';
  } catch (e) {
    //do nothing
  }
  routes = [{
    path: '/',
    name: 'root',
    redirect: '/fzb-zhaohuo'
  }, {
    path: "/fzb-zhaohuo", //找货助手
    name: "zhaohuo",
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MTAT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }];
} else {
  var setHead = function setHead() {
    // ===== 1. title =====
    document.title = '纺支宝服装网-服装批发服装网销货源一件代发_服装批发货源平台上纺支宝';

    // ===== 2. favicon =====
    var iconLink = document.querySelector('#icon-link');
    if (!iconLink) {
      iconLink = document.createElement('link');
      iconLink.id = 'icon-link';
      iconLink.rel = 'icon';
      document.head.appendChild(iconLink);
    }
    iconLink.href = 'https://qiniu.zhaojiafang.com/data/upload/icon/fzb.jpg?_t=' + Date.now();

    // ===== 3. keywords =====
    var keywords = document.querySelector('meta[name="keywords"]');
    if (!keywords) {
      keywords = document.createElement('meta');
      keywords.name = 'keywords';
      document.head.appendChild(keywords);
    }
    keywords.content = '纺支宝服装网,常熟服装网,服装,服装批发,纺支宝服装批发,服装货源,服装一件代发,纺支宝服装货源,纺支宝一件代发,纺支宝常熟服装网';

    // ===== 4. description =====
    var description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.name = 'description';
      document.head.appendChild(description);
    }
    description.content = '纺支宝（常熟服装网）是专业的服装批发货源及一件代发平台。纺支宝服装网集服装批发、服装网销货源、服装一件代发、服装网店直播货源、服装批发货源等集一体的线上批发营销渠道。为全国电商卖家、网红直播、微商和服装店提供极具性价比的服装批发货源以及方便快捷的一件代发服务。';
  };

  setHead();
}

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: "history",
  base: "/",
  routes: routes
}));
// EXTERNAL MODULE: ./node_modules/vue-ydui/dist/ydui.rem.js
var ydui_rem = __webpack_require__("r8FW");
var ydui_rem_default = /*#__PURE__*/__webpack_require__.n(ydui_rem);

// EXTERNAL MODULE: ./node_modules/vue-ydui/dist/ydui.px.css
var ydui_px = __webpack_require__("l7hk");
var ydui_px_default = /*#__PURE__*/__webpack_require__.n(ydui_px);

// EXTERNAL MODULE: ./src/global/css/styles.css
var styles = __webpack_require__("3BBE");
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);

// EXTERNAL MODULE: ./src/global/css/style.css
var style = __webpack_require__("6L8A");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./src/global/css/font-awesome/css/font-awesome.min.css
var font_awesome_min = __webpack_require__("FMur");
var font_awesome_min_default = /*#__PURE__*/__webpack_require__.n(font_awesome_min);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./config/urlprefix.js
var urlprefix = __webpack_require__("Kf48");

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/api/config.js



var APP_ENV = "production";





/* harmony default export */ var config = ({
  url: "/route",

  baseURL: urlprefix["a" /* CurrentEnvPrefix */].mainApi, //http://192.168.2.105:3006/v1//http://apistaging.fangzhibao.com/v1//http://api.fangzhibao.com/v1

  transformRequest: [function (data) {
    //为了避免qs格式化时对内层对象的格式化先把内层的对象转为
    data.CustData = stringify_default()(data.CustData);
    //由于使用的form-data传数据所以要格式化
    data = lib_default.a.stringify(data);
    return data;
  }],

  transformResponse: [function (data) {
    return data;
  }],

  headers: { "Content-Type": "application/x-www-form-urlencoded" },

  authparams: {
    AppVersion: "3.11",
    Format: "json",
    SystemName: "PC",
    key: "", //005e5c406d39f27598f468c511fedd67
    storeid: "0", //3071
    SignCodeKey: "H5SIGNKEYZJFk3029ydhsuwei192bmch",
    timestamp: new Date().getTime(),
    nosign: "nodejs.sign.no",
    industrialBeltFlag: "1",
    SystemSiteId: js_cookie_default.a.get("SystemSiteId") ? js_cookie_default.a.get("SystemSiteId") : 1
  },

  params: {},

  data: {},

  timeout: 60000,

  withCredentials: false, // default

  responseType: "json", // default

  maxContentLength: 2000,

  maxRedirects: 5, // default

  paramsSerializer: function paramsSerializer(params) {
    return lib_default.a.stringify(params);
  },

  onUploadProgress: function onUploadProgress(progressEvent) {
    // Do whatever you want with the native progress event
  },
  onDownloadProgress: function onDownloadProgress(progressEvent) {
    // Do whatever you want with the native progress event
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300; // default
  }
});
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./src/global/js/memberinfo.js

var key_member = 'member_info';

var _getMember = function _getMember() {
	var data = localStorage.getItem(key_member);
	if (data) {
		try {
			return JSON.parse(data);
		} catch (err) {
			return {};
		}
	}
	return {};
};

var memberinfo__saveMember = function _saveMember(member) {
	if (member) {
		//先查找本地存储的用户信息，如果要存储的用户信息没有key，就用本地的替换
		var mOld = _getMember();
		if (mOld && !member.key) {
			member.key = mOld.key;
		}
		localStorage.setItem(key_member, stringify_default()(member));
	} else {
		localStorage.removeItem(key_member);
	}
};

var MemberInfo = {
	getMemberInfo: function getMemberInfo() {
		return _getMember();
	},
	saveMemberInfo: function saveMemberInfo(member) {
		memberinfo__saveMember(member);
	},
	isLogin: function isLogin() {
		var member = _getMember();
		if (member && member.key) {
			return true;
		}
		return false;
	}
};

/* harmony default export */ var memberinfo = (MemberInfo);
// CONCATENATED MODULE: ./src/api/API.js









var MD5 = __webpack_require__("eCz2");

var API_initKey = function initKey() {
	var m = memberinfo.getMemberInfo();
	var c = js_cookie_default.a.get("key");
	if (!lodash_default.a.isEmpty(m) || !lodash_default.a.isEmpty(c)) {
		config.authparams.key = m.key || c;
	}
};

var API_initStoreId = function initStoreId() {
	var id = API__getStoreid();
	config.authparams.storeid = id;
};

var _saveStoreid = function _saveStoreid(store_id) {
	localStorage.setItem('storeid', store_id);
};

var API__getStoreid = function _getStoreid() {
	var id = config.authparams.storeid;
	if (!id) {
		id = localStorage.getItem('storeid');
	}
	return id;
};

var API__saveSystemSiteId = function _saveSystemSiteId(SystemSiteId) {
	js_cookie_default.a.set('SystemSiteId', SystemSiteId);
};

//获取登录权限
API_initKey();
//获取app id
API_initStoreId();

var API_API = function () {
	function API() {
		classCallCheck_default()(this, API);
	}

	createClass_default()(API, [{
		key: 'get',

		//获取已授权列表
		value: function get(param) {
			var _params = {};
			config.data = {};
			lodash_default.a.map(config.authparams, function (value, key) {
				_params[key] = value;
			});

			config.params = _params;
			lodash_default.a.extend(config.params, param.param);
			config.params = this.signCodeRequest(config.params);
			return axios_default.a.get(param.api, config);
		}
		//添加授权

	}, {
		key: 'post',
		value: function post(param) {
			var _params = {};
			config.params = {};
			lodash_default.a.map(config.authparams, function (value, key) {
				_params[key] = value;
			});
			config.data = _params;
			lodash_default.a.extend(config.data, param.param);
			config.data = this.signCodeRequest(config.data);
			return axios_default.a.post(param.api, {}, config);
		}
	}, {
		key: 'uploadFile',
		value: function uploadFile(param, fileName, type, callbackProgress, callbackResult) {
			var _params = {};
			//拼接参数begin
			//获取公共参数到_params中
			lodash_default.a.map(config.authparams, function (value, key) {
				_params[key] = value;
			});
			//将公共参数和页面参数合并到_params中
			lodash_default.a.extend(_params, param.param);
			delete _params[fileName];
			//生成签名
			_params = this.signCodeRequest(_params);
			//当type为真时表示上传文件，node.js服务器需要把参数拼接到url中
			var api = config.baseURL + param.api;
			if (type) {
				lodash_default.a.map(_params, function (value, key) {
					if (api.indexOf('?') < 0) {
						api += '?';
					}
					api += '&' + key + '=' + value;
				});
			}
			//将请求参数转为表单
			var _formData = new FormData();
			_formData.append(fileName, param.param[fileName]);
			lodash_default.a.map(_params, function (value, key) {
				_formData.append(key, value);
			});
			return axios_default()({
				url: api,
				method: 'post',
				headers: { 'Content-Type': 'multipart/form-data' },
				onUploadProgress: function onUploadProgress(progressEvent) {
					//原生获取上传进度的事件
					if (progressEvent.lengthComputable) {
						//属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
						var _progress = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%';
						callbackProgress(_progress);
					}
				},
				data: _formData
			}).then(function (res) {
				// console.log('上传成功');
				callbackResult(res);
			}).catch(function (error) {
				// console.log('上传失败')
				callbackResult(error);
			});
		}

		//资源上传

	}, {
		key: 'uploadResource',
		value: function uploadResource(param, callbackProgress, callbackResult) {
			return axios_default()({
				url: urlprefix["a" /* CurrentEnvPrefix */].main + param.api, //BASE_URL + '/handler/material/upload',
				method: 'post',
				headers: { 'Content-Type': 'multipart/form-data' },
				onUploadProgress: function onUploadProgress(progressEvent) {
					//原生获取上传进度的事件
					if (progressEvent.lengthComputable) {
						//属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
						var _progress = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%';
						callbackProgress(_progress);
					}
				},
				data: param.formdata
			}).then(function (res) {
				// console.log('上传成功');
				callbackResult(res);
			}).catch(function (error) {
				// console.log('上传失败')
				callbackResult(error);
			});
		}
	}, {
		key: 'reqSuccess',
		value: function reqSuccess(obj, msg) {
			obj.$message({
				message: msg,
				type: 'success'
			});
		}
	}, {
		key: 'reqFail',
		value: function reqFail(obj, msg) {
			obj.$message({
				message: msg,
				type: 'success'
			});
		}
	}, {
		key: 'setMKey',
		value: function setMKey(member) {
			config.authparams.key = member;
		}
	}, {
		key: 'getMKey',
		value: function getMKey() {
			return config.authparams.key;
		}
	}, {
		key: 'setStoreid',
		value: function setStoreid(store_id) {
			config.authparams.storeid = store_id;
			_saveStoreid(store_id);
		}
	}, {
		key: 'getStoreid',
		value: function getStoreid() {
			var id = config.authparams.storeid;
			if (!id) {
				id = API__getStoreid();
			}
			return id;
		}
	}, {
		key: 'setSiteId',
		value: function setSiteId(SystemSiteId) {
			config.authparams.SystemSiteId = SystemSiteId;
			API__saveSystemSiteId(SystemSiteId);
		}
	}, {
		key: 'signCodeRequest',
		value: function signCodeRequest(obj) {
			var newkeys = keys_default()(obj).sort();
			var newObj = {};
			var SignCode = '';
			newkeys.forEach(function (item, index) {
				if (item.indexOf(':') == -1 && item != 'SignCodeKey') {
					var v = obj[item] == undefined ? '' : obj[item];
					newObj[item] = v;
					SignCode += v;
				}
			});
			SignCode += config.authparams.SignCodeKey;
			newObj['Sign'] = new MD5().update(SignCode).digest('hex');
			return newObj;
		}
	}]);

	return API;
}();

/* harmony default export */ var api_API = (API_API);
// CONCATENATED MODULE: ./src/api/ZJF.js






var ZJF__params = {};

var ZJF_initKey = function initKey() {
	var m = memberinfo.getMemberInfo();
	if (!lodash_default.a.isEmpty(m)) {
		config.authparams.key = m.key;
	}
};

//获取登录权限
ZJF_initKey();

var ZJF_ZJF = function () {
	function ZJF() {
		classCallCheck_default()(this, ZJF);
	}

	createClass_default()(ZJF, [{
		key: 'location',

		//获取已授权列表
		value: function location(param) {
			lodash_default.a.map(config.authparams, function (value, key) {
				param += '&' + key + '=' + value;
			});
			param += '&vuetype=1';
			window.location.href = param;
		}
	}]);

	return ZJF;
}();

/* harmony default export */ var api_ZJF = (ZJF_ZJF);
// CONCATENATED MODULE: ./src/global/js/helper.js


var isDebug = false;

var helper = {
	log: function log(msg) {
		if (isDebug) {
			console.log(msg);
		}
	},
	sortList: function sortList(type, val, arr, key) {
		//type:1数字,0字符
		//val:0升序,1降序
		return arr.sort(function (a, b) {
			var x = a[key];
			var y = b[key];
			if (type == 1) {
				if (val) {
					return x > y ? -1 : x < y ? 1 : 0;
				} else {
					return x < y ? -1 : x > y ? 1 : 0;
				}
			} else {
				if (val) {
					return x.localeCompare(y);
				} else {
					return y.localeCompare(x);
				}
			}
		});
	},
	htmltitle: function htmltitle(title) {
		document.title = title;
	}
};

/* harmony default export */ var js_helper = (helper);
// CONCATENATED MODULE: ./src/global/js/common.js





var common_api = new api_API();

var goods = [];
var store = [];
var skuword = [];

var sourec = {
  appversion: 1.0,
  fromWhere: { h5: "h5", ios: "iosapp", android: "androidapp" },
  isFromApp: false, //	是否来自app
  sfrom: "",
  key: "",
  isIos: "",
  isAndroid: "",
  plapi: urlprefix["a" /* CurrentEnvPrefix */].plapi, // 'http://api-pl-mobile.fangzhibao.com/api',
  extapi: urlprefix["a" /* CurrentEnvPrefix */].extapi, // 'http://extapi.fangzhibao.com/v1',
  productionUrl: urlprefix["a" /* CurrentEnvPrefix */].main, // 'http://www.fangzhibao.com',//生产环境链接跳转的域名
  productionDetailUrl: urlprefix["a" /* CurrentEnvPrefix */].productionDetailUrl, // 'http://detail.fangzhibao.com',//生产环境链接跳转的域名(带detail的)
  qiniu: urlprefix["a" /* CurrentEnvPrefix */].qiniu,
  sitehost: js_cookie_default.a.get("SystemSiteId") == 1 ? "/cs" : js_cookie_default.a.get("SystemSiteId") == 2 ? "/zl" : js_cookie_default.a.get("SystemSiteId") == 3 ? "/gz" : js_cookie_default.a.get("SystemSiteId") == 4 ? "/csnvz" : js_cookie_default.a.get("SystemSiteId") == 5 ? "/csdmnvz" : js_cookie_default.a.get("SystemSiteId") == 6 ? "/xt" : "/cs",
  sitehost1: js_cookie_default.a.get("SystemSiteId") == 1 ? "" : js_cookie_default.a.get("SystemSiteId") == 2 ? "/zl" : js_cookie_default.a.get("SystemSiteId") == 3 ? "/gz" : js_cookie_default.a.get("SystemSiteId") == 4 ? "/csnvz" : js_cookie_default.a.get("SystemSiteId") == 5 ? "/csdmnvz" : js_cookie_default.a.get("SystemSiteId") == 6 ? "/xt" : "/cs"
};

var siteinfo = {
  site: {}
};
var _barHeight = window.control ? window.control.getStateBarHeight() : 0;

var common__saveGoodsword = function _saveGoodsword(goodsword) {
  localStorage.setItem("goodsword", stringify_default()(goodsword));
};
var common__setSkuword = function _setSkuword(goodsword) {
  localStorage.setItem("skuword", stringify_default()(goodsword));
};
var _getSkuword = function _getSkuword() {
  var goodsword = [];
  goodsword = JSON.parse(localStorage.getItem("skuword"));
  return goodsword;
};
var _getGoodsword = function _getGoodsword() {
  var goodsword = [];
  goodsword = JSON.parse(localStorage.getItem("goodsword"));
  return goodsword;
};
var common__saveStoreword = function _saveStoreword(storeword) {
  localStorage.setItem("storeword", stringify_default()(storeword));
};
var _getStoreword = function _getStoreword() {
  var storeword = [];
  storeword = JSON.parse(localStorage.getItem("storeword"));
  return storeword;
};
var _delGoodsword = function _delGoodsword() {
  localStorage.removeItem("goodsword");
};
var _delStoresword = function _delStoresword() {
  localStorage.removeItem("storeword");
};
var _delSkusword = function _delSkusword() {
  localStorage.removeItem("skuword");
};

var _urlParse = function _urlParse() {
  var obj = {};
  var reg = /[?&][^?&]+=[^?&%]+/g;
  var url = window.location.search;
  var arr = url.match(reg) || [];
  arr.forEach(function (item) {
    var tempArr = item.substring(1).split("=");
    var key = decodeURIComponent(tempArr[0]);
    var val = decodeURIComponent(tempArr[1]);
    obj[key] = val;
  });
  return obj;
};

var changePageHeader = function changePageHeader() {
  if (sourec.isFromApp) {
    document.getElementById("apptip").style.display = "none";
    if (document.getElementById("header")) {
      document.getElementById("header").style.display = "none";
      document.getElementById("h-content").style.cssText = "padding-top:0 !important;";
    }
  }
};
var common_patchUrl = function patchUrl(type, url) {
  return urlprefix["a" /* CurrentEnvPrefix */][type] + url;
};
function _addSpm(spm) {
  var params = { spm_code: spm };
  common_api.post({ api: "/ad/spm", param: params }).then(function (response) {});
}

var _common = {
  getSourec: function getSourec() {
    return sourec;
  },
  getSiteinfo: function getSiteinfo() {
    return siteinfo;
  }, //	来自app的标识
  //是否APP过来，需隐藏头部
  setIsFromApp: function setIsFromApp() {
    return appversion;
    // sfrom = GetQueryString('isfrom');
    // if (sfrom && sfrom!='null') { isFromApp = sfrom.length > 0; }
    // // 默认是隐藏头部的；如果是从app过来的就隐藏，反之显示
    // if (isFromApp) { $("#header").css("display","none"); $("#bottom").css("display","none"); }
    // else { $("#header").css("display","block"); $("#bottom").css("display","block"); }
  },
  setGoodsword: function setGoodsword(goodsword) {
    if (!goods) {
      goods = [];
    }
    goods.push(goodsword);
    common__saveGoodsword(goods);
  },
  setSkuword: function setSkuword(goodsword) {
    if (!skuword) {
      skuword = [];
    }
    skuword.push(goodsword);
    common__setSkuword(skuword);
  },
  getSkuword: function getSkuword() {
    skuword = _getSkuword();
    return skuword;
  },

  getGoodsword: function getGoodsword() {
    goods = _getGoodsword();
    return goods;
  },
  setStoreword: function setStoreword(storeword) {
    if (!store) {
      store = [];
    }
    store.push(storeword);
    common__saveStoreword(store);
  },
  getStoreword: function getStoreword() {
    store = _getStoreword();
    return store;
  },
  delGoodsword: function delGoodsword() {
    goods = _delGoodsword();
    return goods;
  },
  delStoresword: function delStoresword() {
    store = _delStoresword();
    return store;
  },
  delSkusword: function delSkusword() {
    skuword = _delSkusword();
    return skuword;
  },
  urlParse: function urlParse() {
    param = _urlParse();
    return param;
  },
  init: function init() {
    var params = _urlParse(); //所以分割出来的参数
    sourec.key = params.key;
    // sourec.isFromApp = true;
    sourec.isFromApp = params.isfrom ? true : false;
    var u = navigator.userAgent;
    changePageHeader();
    var u = navigator.userAgent;
    sourec.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    sourec.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    // appversion =params.appversion;
    // if(key){
    // 	//通过key请求用信息
    // 	//存储用户信息
    // }
  },
  openApp: function openApp(cb) {
    var href = "";
    //识别系统
    var u = navigator.userAgent;
    var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isChrome = window.navigator.userAgent.indexOf("Chrome") !== -1;
    if (isIos) {
      href = "appzhaojiafangcs://HomeZJFController";
    } else if (isAndroid) {
      href = "zhaojiafang://Home";
    }
    location.href = href;
    setTimeout(function () {
      location.href = "/common/downloadapp";
    }, 1000);
    setTimeout(function () {
      location.reload();
    }, 4000);
  },
  barHeight: function barHeight() {
    return _barHeight;
  },
  addSPM: function addSPM(spm) {
    _addSpm(spm);
  },
  getlinkToErpUrl: function getlinkToErpUrl(url, query, member_center) {
    var token = js_cookie_default.a.get("erp_access_token");
    if (member_center) {
      return common_patchUrl("user", url + "?token=" + (token + query));
    }
    return common_patchUrl("erp", url + "?token=" + (token + query));
  }
};

/* harmony default export */ var common = (_common);
// EXTERNAL MODULE: ./node_modules/vue-clipboard2/vue-clipboard.js
var vue_clipboard = __webpack_require__("wvfG");
var vue_clipboard_default = /*#__PURE__*/__webpack_require__.n(vue_clipboard);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/public/publictop.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var publictop = ({
  // props: {
  //   siteData: {
  //     type: Object,
  //     required: false,
  //     default: {}
  //   }
  // },
  data: function data() {
    return {
      CurrentEnvPrefix: urlprefix["a" /* CurrentEnvPrefix */],
      membername: "",
      ref_url: "",
      member_mobile: "",
      userLink: "",
      orderListLink: "",
      site_phone: "",
      sitelist: [],
      siteData: {},
      siteDataObj: {},
      sitename: "",
      sitehost: "",
      site_group: []
    };
  },

  methods: {
    checkPower: function checkPower(modules) {
      return this.$Api.get({
        api: this.Common.getSourec().plapi + "/alpha_test/check_power",
        param: { modules: modules }
      });
    },
    memberLink: function memberLink(e) {
      this.userLink = common.getlinkToErpUrl("/#/account/info", "", false);
      this.orderListLink = common.getlinkToErpUrl("/#/trade/orderhandle", "&key=0", false);
    },
    goout: function goout() {
      window.location.href = urlprefix["a" /* CurrentEnvPrefix */].login + "/login/index/logout?rewrite_url=" + this.ref_url;
    },
    uploadChange: function uploadChange(e) {
      var files = e.target.files[0];
      var _formData = new FormData();
      var _this = this;
      _formData.append("name", "card_z");
      _formData.append("key", this.$Api.getMKey());
      _formData.append("card_z", files);
      this.$Api.uploadResource({
        api: "/mobile/index.php?act=goods&op=search",
        formdata: _formData
      }, function (callbackProgress) {
        _this.$nextTick(function () {
          _this.progress = callbackProgress;
          // console.log(_this.progress)
        });
      }, function (callBackResult) {
        //处理数据，跳到goodslist页面
        var param = callBackResult.data || [];
        var result = param.length > 0 ? param[0] : null;
        if (result) {
          var href = urlprefix["a" /* CurrentEnvPrefix */].main + _this.Common.getSourec().sitehost + "/shop/index.php?act=search&op=goods_search&goods_id_list=" + result;
          window.location.href = href;
        }
      }).then(function (response) {});
    },
    siteClick: function siteClick(child) {
      var href = urlprefix["a" /* CurrentEnvPrefix */].main + "/" + child.site_code + "/";
      this.$Api.setSiteId(child.site_id);
      this.sitename = child.site_name;
      js_cookie_default.a.set("site_name", this.sitename);
      window.location.href = href;
    },
    getSetList: function getSetList() {
      var _this2 = this;

      this.$Api.get({
        api: this.Common.getSourec().plapi + "/site/get_page_site_list"
      }).then(function (response) {
        if (response.data.ResponseStatus == 0) {
          _this2.siteData = response.data.datas;
          _this2.siteDataObj = _this2.siteData;
          var data = _this2.siteDataObj;
          _this2.sitelist = _this2.siteDataObj.site_list;
          _this2.site_group = _this2.siteDataObj.site_group_all;

          var SystemSiteId = js_cookie_default.a.get("SystemSiteId") ? js_cookie_default.a.get("SystemSiteId") : data.site_id;
          var _this = _this2;
          _this2.site_group.forEach(function (item, n, m) {
            if ([1, 2, 4].includes(item.site_group_id)) {
              item.hidden = false;
            } else {
              item.hidden = true;
            }
            item.children.forEach(function (i, n, m) {
              if (i.site_id == SystemSiteId) {
                _this.sitename = item.site_group_name + "-" + i.site_name;
                js_cookie_default.a.set("site_name", _this.sitename);
              }
            });
          });
        }
      });
    }
  },

  // watch: {
  //   siteData: function(newVal, oldBal) {
  //     this.siteDataObj = newVal;
  //     let data = this.siteDataObj;
  //     this.sitelist = this.siteDataObj.site_list;
  //     this.site_group = this.siteDataObj.site_group;
  //     var SystemSiteId = Cookies.get("SystemSiteId")
  //       ? Cookies.get("SystemSiteId")
  //       : data.site_id;
  //     var _this = this;
  //     this.site_group.forEach(function(item, n, m) {
  //       item.children.forEach(function(i, n, m) {
  //         if (i.site_id == SystemSiteId) {
  //           _this.sitename = item.site_group_name + "-" + i.site_name;
  //         }
  //       });
  //     });
  //   }
  // },
  mounted: function mounted() {
    var _this = this;
    _this.getSetList();
    setTimeout(function () {
      var site = _this.Common.getSourec().site;
      _this.site_phone = site ? site.site_phone : "";
    }, 500);
    this.membername = js_cookie_default.a.get("member_name") || "";
    this.member_mobile = js_cookie_default.a.get("member_mobile") || "";
    if (js_cookie_default.a.get("key")) {
      this.$Api.setMKey(js_cookie_default.a.get("key"));
      this.memberLink();
    }
    this.ref_url = encodeURIComponent(window.location.href);

    var member_name = js_cookie_default.a.get("member_name");
    var member_mobile = js_cookie_default.a.get("member_mobile");
    var member_id = js_cookie_default.a.get("partner_id");
    (function (w, d, e, x) {
      w[e] = function () {
        w.cbk = w.cbk || [];
        w.cbk.push(arguments);
      };
      x = d.createElement("script");
      x.async = true;
      x.id = "zhichiScript";
      x.className = "zcBtn", //该class可自行设置，只需要在使用的自定义入口上同名即可
      x.src = "https://zhaojiafang.soboten.com/chat/frame/v2/entrance.js?sysnum=5182b72b5d8d40259b4b0c8f93baeaa0";
      d.body.appendChild(x);
    })(window, document, "zc");
    zc("config", {
      //设置自定义按钮生效
      custom: true,
      to_customsys_open_style: 1,
      msg_flag: 1,
      uname: member_name,
      // tel:member_mobile,
      partnerid: member_id
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17fb45d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/publictop.vue
var publictop_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"public-top color-font-666 "},[_c('div',{staticClass:"w1200 topbar"},[_c('div',{staticClass:"user-entry f-l"},[_c('div',{staticClass:"qm-ul-li f-l",staticStyle:{"width":"145px"}},[_c('div',{staticClass:"qm-ch-div"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(_vm.sitename)+" ["),_c('span',{staticClass:"main-color"},[_vm._v("切换")]),_vm._v("]")])]),_vm._v(" "),_c('div',{staticClass:"qm-ch-div1",staticStyle:{"background-color":"transparent","border":"none"}},[_c('div',{staticClass:"home-tab-hover"},_vm._l((_vm.site_group),function(item){return (!item.hidden)?_c('div',{key:item.site_group_title,staticClass:"home-tab-list"},[_c('img',{staticClass:"site-row-icon",attrs:{"src":item.icon_url}}),_vm._v(" "),_c('span',{staticClass:"site-row-title"},[_vm._v(_vm._s(item.site_group_title))]),_vm._v(" "),_vm._l((item.children),function(child,jindex){return (child.is_show == 1)?_c('a',{key:jindex,staticClass:"site-row-name",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.siteClick(child)}}},[_vm._v(_vm._s(child.site_name))]):_vm._e()})],2):_vm._e()}),0)])]),_vm._v(" "),(_vm.membername)?_c('div',[_c('span',[_vm._v("您好 "),_c('a',{attrs:{"href":_vm.userLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.membername))]),_vm._v(",欢迎来到")]),_c('a',{staticClass:"main-color",attrs:{"href":_vm.CurrentEnvPrefix.main + _vm.Common.getSourec().sitehost,"target":"_blank"}},[_vm._v("纺支宝")]),_c('span',[_vm._v(" [ "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goout()}}},[_vm._v("退出")]),_vm._v(" ] ")])]):_c('div',[_c('a',{staticClass:"main-color",attrs:{"href":_vm.CurrentEnvPrefix.main + _vm.Common.getSourec().sitehost,"target":"_blank"}},[_vm._v("纺支宝")]),_c('span',[_vm._v("欢迎你！")]),_vm._v(" "),_c('a',{staticStyle:{"margin-left":"20px"},attrs:{"href":_vm.CurrentEnvPrefix.login + '/?ref_url=' + _vm.ref_url}},[_vm._v("登录")]),_vm._v(" "),_c('span',[_c('a',{staticStyle:{"margin-left":"20px","color":"var(--main-color)"},attrs:{"href":_vm.CurrentEnvPrefix.login + '/login/login/register'}},[_vm._v("免费注册")])])])]),_vm._v(" "),_c('div',{staticClass:"quick-menu f-r"},[_c('ul',{staticClass:"qm-ul"},[_c('li',{staticClass:"qm-ul-li"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"qm-ch-div1"},[_c('ul',{staticClass:"qm-ch-ul"},[_c('li',[_c('a',{attrs:{"href":"javascript:;"}},[_c('label',[_vm._v("以图搜款"),_c('input',{ref:"upload",staticClass:"input-file",attrs:{"type":"file","id":"file","name":"card_z","accept":"image/png,image/jpeg,image/gif","hidefocus":"true"},on:{"change":_vm.uploadChange}})])])])])])]),_vm._v(" "),_c('li',{staticClass:"qm-ul-li"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"qm-ch-div1"},[_c('ul',{staticClass:"qm-ch-ul"},[_c('li',[_c('a',{attrs:{"href":_vm.CurrentEnvPrefix.main +
                          _vm.Common.getSourec().sitehost +
                          '/index.php?act=show_joinin&op=register_store',"target":"_blank"}},[_vm._v("招商入驻")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.CurrentEnvPrefix.newMain,"target":"_blank"}},[_vm._v("商家登录")])])])])]),_vm._v(" "),_c('li',{staticClass:"qm-ul-li"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"qm-ch-div1"},[_c('ul',{staticClass:"qm-ch-ul"},[_c('li',[_c('a',{attrs:{"href":_vm.orderListLink,"target":"_blank"}},[_vm._v("订单列表")])])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('li',{staticClass:"qm-ul-li qm-ul-li-rx"},[_c('div',{staticClass:"ng-nav-tel"},[_c('span',{staticClass:"ng-tel-title"},[_vm._v("服务热线：")]),_vm._v(" "),_c('span',{staticClass:"ng-tel-nub main-color"},[_vm._v(_vm._s(_vm.site_phone.value))])])])])])])])])}
var publictop_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qm-ch-div"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("功能服务 "),_c('i',{staticClass:"fa fa-angle-down",attrs:{"aria-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qm-ch-div"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("我是商家 "),_c('i',{staticClass:"fa fa-angle-down",attrs:{"aria-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qm-ch-div"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("我的商城 "),_c('i',{staticClass:"fa fa-angle-down",attrs:{"aria-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"qm-ul-li qm-ul-li-wx",staticStyle:{"width":"80px"}},[_c('div',{staticClass:"qm-ch-div"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("在线客服 "),_c('i',{staticClass:"fa fa-angle-down",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"qm-ch-div1"},[_c('ul',{staticClass:"qm-ch-ul"},[_c('li',[_c('a',{staticClass:"zcBtn",attrs:{"href":"javascript:;"}},[_vm._v("在线客服\n                      ")])])])])])}]
var publictop_esExports = { render: publictop_render, staticRenderFns: publictop_staticRenderFns }
/* harmony default export */ var public_publictop = (publictop_esExports);
// CONCATENATED MODULE: ./src/components/public/publictop.vue
function publictop_injectStyle (ssrContext) {
  __webpack_require__("vQGE")
}
var publictop_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var publictop___vue_template_functional__ = false
/* styles */
var publictop___vue_styles__ = publictop_injectStyle
/* scopeId */
var publictop___vue_scopeId__ = "data-v-17fb45d0"
/* moduleIdentifier (server only) */
var publictop___vue_module_identifier__ = null
var publictop_Component = publictop_normalizeComponent(
  publictop,
  public_publictop,
  publictop___vue_template_functional__,
  publictop___vue_styles__,
  publictop___vue_scopeId__,
  publictop___vue_module_identifier__
)

/* harmony default export */ var components_public_publictop = (publictop_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/public/header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var header = ({
    data: function data() {
        return {
            CurrentEnvPrefix: urlprefix["a" /* CurrentEnvPrefix */],
            hotshow: false,
            hotkeyword: [],
            goodskeyword: [],
            tab: ['商品', '厂家', 'SKU编码'],
            tabnum: 0,
            goodssearch: true,
            searchlist: [],
            storesearchlist: [],
            list: [],
            brandlist: [],
            site_logo: {},
            skusearchlist: []
        };
    },

    methods: {
        tabsearchClick: function tabsearchClick(index) {
            this.tabnum = index;
            if (index == 1) {
                this.goodssearch = false;
            } else {
                this.goodssearch = true;
            }
            this.getHotKeyWord();
        },
        searchClick: function searchClick() {
            this.hotshow = true;
        },
        hiddensearch: function hiddensearch() {
            this.hotshow = false;
        },
        getHotKeyWord: function getHotKeyWord() {
            var _this2 = this;

            this.$Api.get({ api: '/fragment/hotkeywords' }).then(function (response) {
                _this2.hotkeyword = response.data.datas;
                if (_this2.goodssearch) {
                    _this2.goodskeyword = _this2.hotkeyword.goods;
                } else {
                    _this2.goodskeyword = _this2.hotkeyword.store;
                }
            });
        },
        uploadChange: function uploadChange(e) {
            var files = e.target.files[0];
            var _formData = new FormData();
            var _this = this;
            _formData.append('name', 'card_z');
            _formData.append('key', this.$Api.getMKey());
            _formData.append('card_z', files);
            this.$Api.uploadResource({
                api: '/mobile/index.php?act=goods&op=search',
                formdata: _formData
            }, function (callbackProgress) {
                _this.$nextTick(function () {
                    _this.progress = callbackProgress;
                    // console.log(_this.progress)
                });
            }, function (callBackResult) {
                //处理数据，跳到goodslist页面
                var param = callBackResult.data || [];
                var result = param.length > 0 ? param[0] : null;
                var images = param.length > 0 ? param[1] : null;
                if (result || images) {
                    var href = urlprefix["a" /* CurrentEnvPrefix */].search + _this.Common.getSourec().sitehost1 + "/search/index/searchbyimage?goods_id=&images=" + images;
                    window.location.href = href;
                }
            }).then(function (response) {});
        },
        searchsureClick: function searchsureClick() {
            var keyword = this.$refs.inputname.value;
            this.kwsearchClick(keyword);
        },
        kwsearchClick: function kwsearchClick(keyword) {
            console.log(this.tabnum);
            if (this.goodssearch) {
                if (this.tabnum == 1 || this.tabnum == 0) {
                    this.Common.setGoodsword(keyword);
                    window.location.href = urlprefix["a" /* CurrentEnvPrefix */].search + this.Common.getSourec().sitehost1 + "/?1=1&keyword=" + keyword;
                } else if (this.tabnum == 2) {
                    this.Common.setSkuword(keyword);
                    window.location.href = urlprefix["a" /* CurrentEnvPrefix */].productionDetailUrl + "/goods/index?goods_id=" + keyword;
                }
                // }else if(this.tabnum == 2){
                //     this.Common.setGoodsword(keyword);
                //     window.location.href = CurrentEnvPrefix.search+this.Common.getSourec().sitehost1+"/?1=1&goods_serial="+keyword;
                // }
            } else {
                this.Common.setStoreword(keyword);
                window.location.href = urlprefix["a" /* CurrentEnvPrefix */].search + this.Common.getSourec().sitehost1 + "/search/store&keyword=" + keyword;
            }
        },
        delword: function delword() {
            var _this3 = this;

            if (this.tabnum == 0) {
                this.$dialog.confirm({
                    mes: '确定要删除全部历史搜索吗？',
                    opts: function opts() {
                        _this3.Common.delGoodsword();
                        _this3.searchlist = _this3.Common.getGoodsword();
                    }
                });
            } else if (this.tabnum == 1) {
                this.$dialog.confirm({
                    mes: '确定要删除全部历史搜索吗？',
                    opts: function opts() {
                        _this3.Common.delStoresword();
                        _this3.storesearchlist = _this3.Common.getStoreword();
                    }
                });
            } else if (this.tabnum == 2) {
                this.$dialog.confirm({
                    mes: '确定要删除全部历史搜索吗？',
                    opts: function opts() {
                        _this3.Common.delSkusword();
                        _this3.storesearchlist = _this3.Common.getSkuword();
                    }
                });
            }
        },
        getList: function getList() {
            var _this4 = this;

            this.$Api.get({ api: '/ad/list', param: { ad_type: 'commonsearch.history.ads' } }).then(function (response) {
                var datas = response.data.datas;
                var lastindex = _this4.$cookie.get('hhtj') || '';
                if (lastindex == '') {
                    lastindex = 0;
                    _this4.$cookie.set('hhtj', lastindex, '1D');
                } else {
                    lastindex = lastindex == 0 ? 1 : 0;
                }
                _this4.$cookie.set('hhtj', lastindex, '1D');
                _this4.list = datas[lastindex];
            });
        },
        getBrandList: function getBrandList() {
            var _this5 = this;

            this.$Api.get({ api: '/ad/list', param: { ad_type: 'commonsearch.brandlist' } }).then(function (response) {
                _this5.brandlist = response.data.datas;
            });
        },
        getLogo: function getLogo() {
            var _this = this;
            setTimeout(function () {
                var site = _this.Common.getSourec().site;
                _this.site_logo = site ? site.site_logo : '';
            }, 500);
        }
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted: function mounted() {
        this.getHotKeyWord();
        window.addEventListener('scroll', this.handleScroll);
        this.searchlist = this.Common.getGoodsword() || [];
        for (var i = 0; i < this.searchlist.length; i++) {
            for (var m = 0; m < this.searchlist.length; m++) {
                if (i != m && this.searchlist[i] == this.searchlist[m]) {
                    this.searchlist.splice(m, 1);
                }
            }
        }
        this.storesearchlist = this.Common.getStoreword() || [];
        this.skusearchlist = this.Common.getSkuword() || [];
        for (var i = 0; i < this.storesearchlist.length; i++) {
            for (var m = 0; m < this.storesearchlist.length; m++) {
                if (i != m && this.storesearchlist[i] == this.storesearchlist[m]) {
                    this.storesearchlist.splice(m, 1);
                }
            }
        }
        this.getList();
        this.getBrandList();
        this.getLogo();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316e8626","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/header.vue
var header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ng-header"},[_c('div',{staticClass:"w1200 top-header"},[_c('div',{staticClass:"ng-site-logo"},[_c('a',{attrs:{"href":_vm.CurrentEnvPrefix.main+_vm.Common.getSourec().sitehost}},[_c('svg',{staticClass:"injected-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"180.00143432617188","height":"40.2236328125","viewBox":"0 0 180.00143432617188 40.2236328125","fill":"none","data-src":"/svg/cs_logo.svg"}},[_c('g',{attrs:{"opacity":"1","transform":"translate(0 0)  rotate(0)"}},[_c('path',{attrs:{"id":"路径 1-1","fill-rule":"evenodd","fill":"url(#home_svg_style)","opacity":"1","d":"M33.52,0c3.7,0 6.7,3 6.7,6.7v26.82c0,3.7 -3,6.7 -6.7,6.7h-26.82c-3.7,0 -6.7,-3 -6.7,-6.7v-26.82c0,-3.7 3,-6.7 6.7,-6.7zM5.7,27.72h9.76v-3.94h-4.97l4.97,-4.02v-5.02h-4.97l4.97,-4.02v-5.02l-9.76,7.88v5.03v0.07h4.88l-4.88,3.94v5.03zM34.52,23.94c0,-4.06 -3.13,-7.54 -7.19,-7.74c-1.5,-0.08 -2.9,0.29 -4.11,0.98v-4.72h11.3v-3.81h-6.18v-2.95h-4.61v2.95h-6.63v3.81h1.83v14.66c0,1.7 -1.39,3.09 -3.09,3.09h-10.14v4.31h10.4c3.94,0 7.13,-3.19 7.13,-7.12v-4.27c0.31,-1.85 1.95,-3.24 3.9,-3.15c2.04,0.09 3.61,1.86 3.61,3.9v6.86l-5.05,3.78h8.83z"}}),_vm._v(" "),_c('g',{attrs:{"opacity":"1","transform":"translate(49.84912109375 0)  rotate(0)"}},[_c('path',{staticStyle:{"fill":"#141414"},attrs:{"id":"路径 2-2","fill-rule":"evenodd","opacity":"1","d":"M0 40.2235L15.08 40.2235L15.08 34.3535L0 34.3535L0 40.2235Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#141414"},attrs:{"id":"路径 3-3","fill-rule":"evenodd","opacity":"1","d":"M13.13 0L6.7 0L0 10.05L0 15.92L6.14 15.92L0 25.14L0 31L15.08 31L15.08 25.14L6.43 25.14L16.48 10.05L6.43 10.05L13.13 0Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#141414"},attrs:{"id":"路径 4-4","fill-rule":"evenodd","opacity":"1","d":"M80.1729 29.92C80.9029 28.11 81.2629 26.16 81.2629 24.06L81.2429 18.2C81.1729 15.49 78.9529 13.31 76.2229 13.31L68.5229 13.31L68.5229 9.28L85.4629 9.28L85.4629 4.25L68.5229 4.25L68.5229 0L62.1929 0L62.1929 4.25L45.2429 4.25L45.2429 9.28L62.1829 9.28L62.1829 13.31L49.6629 13.31L49.6629 18.34L74.9629 18.34L74.9629 18.34L74.9629 24.06C74.9629 25.3 74.7929 26.45 74.4629 27.48C74.1229 28.51 73.5829 29.44 72.8429 30.26C72.0929 31.08 71.1229 31.79 69.9229 32.39C68.7129 32.98 67.2529 33.46 65.5129 33.82C63.8129 33.46 62.3629 32.98 61.1729 32.39C59.9929 31.79 59.0229 31.09 58.2729 30.29C57.5329 29.48 56.9929 28.56 56.6529 27.53C56.3229 26.49 56.1529 25.33 56.1529 24.06L56.1529 22.5L49.8529 22.5L49.8529 24.06C49.8529 26.19 50.2129 28.16 50.9229 29.97C51.6429 31.78 52.8229 33.38 54.4629 34.78L45.2429 34.78L45.2429 40.22L54.1029 40.22C56.2929 40.22 58.3229 40.14 60.1929 39.99C62.0629 39.84 63.8029 39.61 65.4229 39.3C67.0329 39.61 68.7629 39.84 70.6229 39.99C72.4829 40.14 74.5029 40.22 76.6929 40.22L85.4629 40.22L85.4629 34.78L76.4729 34.79C78.2029 33.36 79.4429 31.74 80.1729 29.92Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#141414"},attrs:{"id":"路径 5-5","fill-rule":"evenodd","opacity":"1","d":"M113.212 0L106.872 0L106.872 4.25L89.9323 4.25L89.9323 12.01L94.9623 12.01L94.9623 9.28L125.122 9.28L125.122 12.01L130.152 12.01L130.152 4.25L113.212 4.25L113.212 0Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#141414"},attrs:{"id":"路径 6-6","fill-rule":"evenodd","opacity":"1","d":"M106.872 18.7132L106.872 23.1832L89.9323 23.1832L89.9323 28.5832L106.872 28.5832L106.872 34.5432L89.9323 34.5432L89.9323 40.2232L130.152 40.2232L130.152 30.9132L123.882 30.9132L123.882 34.5432L113.212 34.5432L113.212 28.5832L130.152 28.5832L130.152 23.1832L113.212 23.1832L113.212 18.7132L130.152 18.7132L130.152 13.3132L89.9323 13.3132L89.9323 18.7132L106.872 18.7132Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#141414"},attrs:{"id":"路径 7-7","fill-rule":"evenodd","opacity":"1","d":"M25.7177 0L25.7177 4.25L17.5577 4.25L17.5577 9.28L20.1077 9.28L20.1077 31.8C20.1077 33.21 18.9677 34.35 17.5577 34.35L17.5577 40.22L20.6277 40.22C23.1177 40.22 25.1377 38.2 25.1377 35.71L25.1377 18.62L35.1877 18.62L35.1877 31.58C35.1877 33.11 33.9477 34.35 32.4177 34.35L30.1677 34.35L30.1677 40.22L35.7077 40.22C38.1977 40.22 40.2177 38.2 40.2177 35.71L40.2177 13.59L25.1377 13.59L25.1377 9.28L40.2177 9.28L40.2177 4.25L32.0577 4.25L32.0577 0L25.7177 0Z"}})])]),_vm._v(" "),_c('defs',[_c('linearGradient',{attrs:{"id":"home_svg_style","x1":"74.04955117674645%","y1":"23.408234119415283%","x2":"21.058357292630035%","y2":"99.9998688697815%","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"var(--home-svg-color-0)","stop-opacity":"1"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"var(--home-svg-color-1)","stop-opacity":"1"}})],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"ng-head-search-bar",attrs:{"id":"search"},on:{"mouseleave":function($event){return _vm.hiddensearch()}}},[_c('ul',{staticClass:"ng-tab"},_vm._l((_vm.tab),function(tab,index){return _c('li',{class:{'current':_vm.tabnum==index},on:{"click":function($event){return _vm.tabsearchClick(index)}}},[_vm._v(_vm._s(tab))])}),0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"inline-block"}},[_c('div',{staticClass:"search-form main-color-border-2"},[_c('input',{attrs:{"type":"hidden","name":"","value":"search"}}),_vm._v(" "),(_vm.tabnum==0)?_c('input',{ref:"inputname",staticClass:"input-text",attrs:{"type":"text","name":"","placeholder":"关键词、货号"},on:{"click":function($event){return _vm.searchClick()}}}):_vm._e(),_vm._v(" "),(_vm.tabnum==1)?_c('input',{ref:"inputname",staticClass:"input-text",attrs:{"type":"text","name":"","placeholder":"请输入厂家关键字"},on:{"click":function($event){return _vm.searchClick()}}}):_vm._e(),_vm._v(" "),(_vm.tabnum==2)?_c('input',{ref:"inputname",staticClass:"input-text",attrs:{"type":"text","name":"","placeholder":"请输入SKU编码"},on:{"click":function($event){return _vm.searchClick()}}}):_vm._e(),_vm._v(" "),_c('label',[_c('input',{staticClass:"brand-color-bg input-submit",attrs:{"type":"submit","name":"","value":""},on:{"click":function($event){return _vm.searchsureClick()}}}),_vm._v(" "),_c('img',{staticStyle:{"position":"absolute","right":"23px","top":"3px","width":"30px","cursor":"pointer"},attrs:{"src":__webpack_require__("fma8")}})])]),_vm._v(" "),_c('div',{staticClass:"main-color main-color-border-2",staticStyle:{"position":"relative","cursor":"pointer","margin-left":"7px","overflow":"hidden","width":"106px","height":"40px","font-size":"12px","background-color":"#fff","border-radius":"8px","float":"left","line-height":"36px","text-align":"center"}},[_c('label',[_c('span',[_c('label',[_c('svg',{staticStyle:{"font-size":"15px","vertical-align":"text-top"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"1em","height":"0.8215em","viewBox":"0 0 20 16.429931640625","fill":"currentColor"}},[_c('path',{attrs:{"opacity":"1","d":"M2.14,2.14h2.15l0.5,-1.5c0.14,-0.35 0.5,-0.64 0.92,-0.64h8.58c0.35,0 0.78,0.29 0.92,0.64l0.5,1.5h2.15c1.21,0 2.14,0.93 2.14,2.15v10c0,1.21 -0.93,2.14 -2.14,2.14h-15.72c-1.14,0 -2.14,-0.93 -2.14,-2.14v-10c0,-1.22 0.93,-2.15 2.14,-2.15zM17.8618,3.21129h-2.93l-0.22,-0.71l-0.5,-1.43h-8.43002l-0.5,1.43l-0.21,0.71h-2.93c-0.57,0 -1.07,0.5 -1.07,1.07v10.00001c0,0.58 0.5,1.08 1.07,1.08h15.72002c0.57,0 1.07,-0.5 1.07,-1.08v-10.00001c0,-0.57 -0.5,-1.07 -1.07,-1.07zM5,8.57227c0,-2.79 2.21,-5 5,-5c2.79,0 5,2.21 5,5c0,2.79003 -2.21,5.00003 -5,5.00003c-2.79,0 -5,-2.21 -5,-5.00003zM13.9318,8.57355c0,-2.14 -1.79,-3.93 -3.93,-3.93c-2.14002,0 -3.93002,1.79 -3.93002,3.93c0,2.14005 1.79,3.93005 3.93002,3.93005c2.14,0 3.93,-1.79 3.93,-3.93005z"}})]),_vm._v(" 以图搜款"),_c('input',{ref:"upload",staticClass:"input-file",attrs:{"type":"file","id":"file","name":"card_z","accept":"image/png,image/jpeg,image/gif","hidefocus":"true"},on:{"change":_vm.uploadChange}})])]),_vm._v(" "),_c('input',{staticClass:"input-file",staticStyle:{"width":"0px","height":"26px","opacity":"0","cursor":"pointer","border":"0"},attrs:{"type":"file","name":"file_search","hidefocus":"true","size":"1"}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hotshow),expression:"hotshow"}],staticClass:"ng-search-tip",staticStyle:{"border-radius":"8px"}},[_c('div',{staticClass:"ng-search-history"},[_c('div',{staticClass:"ng-h-title"},[_vm._v("历史记录"),_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.delword()}}},[_vm._v("清除")])]),_vm._v(" "),_c('ul',{staticClass:"ng-h-list",staticStyle:{"height":"82px","overflow":"hidden"}},[_vm._l((_vm.searchlist),function(list){return (_vm.tabnum==0)?_c('li',[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(list))])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.storesearchlist),function(list){return (_vm.tabnum==1)?_c('li',[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(list))])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.skusearchlist),function(list){return (_vm.tabnum==2)?_c('li',[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(list))])]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"ng-h-title"},[_vm._v("好货推荐")]),_vm._v(" "),_c('div',{staticClass:"ng-h-goods"},[(_vm.list&&_vm.list.ads)?_c('a',{attrs:{"href":_vm.list.ads[0].url,"title":_vm.list.adv_title}},[_c('img',{attrs:{"src":_vm.list.ads[0].pic}})]):_vm._e()])]),_vm._v(" "),(_vm.brandlist.length<=6)?_c('div',{staticClass:"ng-search-hot"},[_c('div',{staticClass:"ng-h-title"},[_vm._v("热门推荐...")]),_vm._v(" "),_c('ul',{staticClass:"ng-hot-brand"},_vm._l((_vm.brandlist),function(list){return _c('li',[_c('a',{attrs:{"href":list.ads[0].url}},[_c('img',{attrs:{"src":list.ads[0].pic}})])])}),0)]):_vm._e(),_vm._v(" "),(_vm.brandlist.length>6)?_c('div',{staticClass:"ng-search-hot1"},[_c('div',{staticClass:"ng-h-title"},[_vm._v("热门推荐...")]),_vm._v(" "),_c('ul',{staticClass:"ng-hot-brand1"},_vm._l((_vm.brandlist),function(list){return _c('li',[_c('a',{attrs:{"href":list.ads[0].url}},[_c('img',{attrs:{"src":list.ads[0].pic}})])])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ng-keyword"},[_c('ul',_vm._l((_vm.goodskeyword),function(keyword){return _c('li',{on:{"click":function($event){return _vm.kwsearchClick(keyword)}}},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(keyword))])])}),0)])])])])])}
var header_staticRenderFns = []
var header_esExports = { render: header_render, staticRenderFns: header_staticRenderFns }
/* harmony default export */ var public_header = (header_esExports);
// CONCATENATED MODULE: ./src/components/public/header.vue
function header_injectStyle (ssrContext) {
  __webpack_require__("ENQs")
}
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = header_injectStyle
/* scopeId */
var header___vue_scopeId__ = "data-v-316e8626"
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  header,
  public_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)

/* harmony default export */ var components_public_header = (header_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/swiper/dist/css/swiper.css
var swiper = __webpack_require__("v2ns");
var swiper_default = /*#__PURE__*/__webpack_require__.n(swiper);

// CONCATENATED MODULE: ./src/utils/fallbackImg.js
var imgFallback = function imgFallback(site_code) {
  switch (site_code) {
    case "/zl":
      return "/static/icon/zl.jpg";
      break;
    case "/cs":
      return "/static/icon/cs.jpg";
      break;
    case "/csdmnvz":
      return "/static/icon/csdmnvz.jpg";
      break;
    default:
      return "";
      break;
  }
};
var imgFallbackLittle = function imgFallbackLittle(site_code) {
  switch (site_code) {
    case "/zl":
      return "/static/icon/zl1.png";
      break;
    case "/cs":
      return "/static/icon/cs1.png";
      break;
    case "/csdmnvz":
      return "/static/icon/csdmnvz1.png";
      break;
    default:
      return "";
      break;
  }
};
// EXTERNAL MODULE: ./node_modules/vue-awesome-swiper/dist/vue-awesome-swiper.js
var vue_awesome_swiper = __webpack_require__("7QTg");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/public/publicnav.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import './global/css/font-awesome/css/font-awesome.min.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'






/* harmony default export */ var publicnav = ({
  // props: {
  //   siteData: {
  //     type: Object,
  //     required: false,
  //     default: {}
  //   }
  // },
  data: function data() {
    return {
      CurrentEnvPrefix: urlprefix["a" /* CurrentEnvPrefix */],
      isshow: false,
      isshow1: -1,
      isshow2: -1,
      classlist: [],
      catelist: [],
      shoplist: [],
      siteData: {},
      siteDataObj: {},
      currentSite: {},
      siteTheme: {
        "1": {
          theme: "CS",
          icon: "/svg/cs.svg",
          site_icon: "/svg/cs_site.svg",
          site_logo: "/svg/cs_logo.svg",
          favicon: "/imgs/icons/cs_favicon.png"
        },
        "4": {
          theme: "ZL",
          icon: "/svg/zl.svg",
          site_icon: "/svg/zl_site.svg",
          site_logo: "/svg/zl_logo.svg",
          favicon: "/imgs/icons/zl_favicon.png"
        },
        "2": {
          theme: "GZ",
          icon: "/svg/gz.svg",
          site_icon: "/svg/gz_site.svg",
          site_logo: "/svg/gz_logo.svg",
          favicon: "/imgs/icons/gz_favicon.png"
        },
        "3": {
          theme: "ZS",
          icon: "/svg/zs.svg",
          site_icon: "/svg/zs_site.svg",
          site_logo: "/svg/zs_logo.svg",
          favicon: "/imgs/icons/zs_favicon.png"
        }
      },

      swiperOption: {
        autoplay: true,
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
        mousewheelControl: true
      }
    };
  },

  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"]
  },
  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    },
    imgUrlLittle: function imgUrlLittle() {
      return imgFallbackLittle(this.Common.getSourec().sitehost);
    }
  },

  methods: {
    //一级下是否存在三级（无三级时弹层二级按三级样式平铺展示）
    hasThirdChild: function hasThirdChild(list) {
      return (list.children || []).some(function (s) {
        return s.children && s.children.length > 0;
      });
    },
    showcategory: function showcategory() {
      this.isshow = true;
    },
    hiddencategory: function hiddencategory() {
      this.isshow = false;
    },
    showsubclass: function showsubclass(index) {
      this.isshow1 = index;
    },
    hiddensubclass: function hiddensubclass(index) {
      this.isshow1 = -1;
    },
    showsubclassItem: function showsubclassItem(index) {
      this.isshow2 = index;
    },
    hiddensubclassItem: function hiddensubclassItem(index) {
      this.isshow2 = -1;
    },
    getClassList: function getClassList() {
      var _this = this;

      // this.$Api.get({api:'/goods/goodsclass', param:{deep:3,has_ad:1}}).then(response => {
      // 	this.classlist=response.data.datas;
      // });
      this.$Api.get({
        api: this.Common.getSourec().plapi + "/goods_display_class/get_display_class_nav?SystemSiteId=" + (js_cookie_default.a.get("SystemSiteId") || 1)
      }).then(function (response) {
        if (response.data.ResponseStatus == 0) {
          _this.classlist = response.data.datas;
        }
      });
    },
    hrefClick: function hrefClick(href) {
      this.$HrefRouter.WebHrefRrouter(href);
    },
    getNavShop: function getNavShop() {
      var _this2 = this;

      this.$Api.get({ api: "/ad/newshop/list" }).then(function (response) {
        _this2.shoplist = response.data.datas;
      });
    },
    getSetList: function getSetList() {
      var _this3 = this;

      console.log(this.siteDataObj, 433435454);
      this.$Api.get({
        api: this.Common.getSourec().plapi + "/site/get_page_site_list"
      }).then(function (response) {
        if (response.data.ResponseStatus == 0) {
          _this3.siteData = response.data.datas;
          _this3.siteDataObj = _this3.siteData;
          var data = _this3.siteDataObj;
          var site_group = _this3.siteDataObj.site_group;
          var SystemSiteId = js_cookie_default.a.get("SystemSiteId") ? js_cookie_default.a.get("SystemSiteId") : data.site_id;
          var that = _this3;
          site_group.forEach(function (item, n, m) {
            item.children.forEach(function (i, n, m) {
              if (i.site_id == SystemSiteId) {
                that.currentSite = extends_default()({}, that.currentSite, that.siteTheme[i.color_type], i, item);
              }
            });
          });
        }
      });
    }
  },
  // watch: {
  //   siteData: function(newVal, oldBal) {
  //     this.siteDataObj = newVal;
  //     let data = this.siteDataObj;
  //     let site_group = this.siteDataObj.site_group;
  //     let SystemSiteId = Cookies.get("SystemSiteId")
  //       ? Cookies.get("SystemSiteId")
  //       : data.site_id;
  //     let that = this;
  //     site_group.forEach(function(item, n, m) {
  //       item.children.forEach(function(i, n, m) {
  //         if (i.site_id == SystemSiteId) {
  //           that.currentSite = {
  //             ...that.currentSite,
  //             ...that.siteTheme[i.color_type],
  //             ...i,
  //             ...item
  //           };
  //         }
  //       });
  //     });
  //   }
  // },
  mounted: function mounted() {
    this.getClassList();
    this.getNavShop();
    this.getSetList();
    var path = this.$route.path;
    var color_type = vue_cookie_default.a.get("color_type") ? vue_cookie_default.a.get("color_type") : "1";
    var color = color_type == "1" ? "#2357E8" : color_type == "2" ? "#FF5556" : color_type == "3" ? "#7A45E6" : color_type == "4" ? "#FC8200" : color_type == "6" ? "#2357E8" : "#2357E8";
    if (path == "/newgoods") {
      this.$refs.xbpa.style.color = color;
    } else if (path == "/hotsearch") {
      this.$refs.rbpa.style.color = color;
    } else if (path == "/brand") {
      this.$refs.ppya.style.color = color;
    } else if (path == "/navigation") {
      this.$refs.cja.style.color = color;
    } else if (path == "/wetchat") {
      this.$refs.wsa.style.color = color;
    } else if (path == "/seasongoods") {
      this.$refs.cxxp.style.color = color;
    } else if (path == "/newtowel") {
      // this.$refs.towel.style.color="#ff2d51";
    } else if (path == "/goodsupplier") {
      // this.$refs.yzsj.style.color="#ff2d51";
    } else if (path == "/topsupplier") {
      // this.$refs.sjyz.style.color="#ff2d51";
    } else if (path == "/purchase") {
      // this.$refs.wjcgj.style.color="#ff2d51";
    } else if (path == "/tianmao") {
      this.$refs.tm.style.color = color;
    } else if (path == "/yiqing") {
      this.$refs.yiqing.style.color = color;
    } else if (path == "/repeatwork") {
      this.$refs.repeatwork.style.color = color;
    } else if (path == "/findgoods") {
      this.$refs.fxhh.style.color = color;
    } else if (path == "/hotstore") {
      this.$refs.hotstore.style.color = color;
    } else if (path == "/jiafangcheng") {
      this.$refs.jiafangcheng.style.color = color;
    } else if (path == "/zhounian") {
      this.$refs.zhounian.style.color = color;
    } else if (path == "/channel") {
      this.$refs.channel.style.color = color;
    } else if (path == "/articlelist") {
      this.$refs.articlelist.style.color = color;
    } else if (path == "/videolist") {
      this.$refs.videolist.style.color = color;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7020207c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/publicnav.vue
var publicnav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"ng-nav main-color-border"},[_c('div',{staticClass:"w1200"},[_c('div',{staticClass:"ng-all-category",on:{"mouseleave":function($event){return _vm.hiddencategory()}}},[_c('div',{staticClass:"ng-ac-title",on:{"mouseenter":function($event){return _vm.showcategory()}}},[_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshow),expression:"isshow"}],staticStyle:{"width":"1200px","position":"absolute","padding-top":"15px"}},[_c('div',{staticClass:"pn-category"},[_c('div',{staticClass:"pn-category-menu"},[_c('ul',{staticClass:"pn-menu"},_vm._l((_vm.classlist),function(list,index){return _c('li',{key:index,staticClass:"pn-menulist",on:{"mouseenter":function($event){return _vm.showsubclass(index)},"mouseleave":function($event){return _vm.hiddensubclass(index)}}},[_c('div',{staticClass:"pn-class"},[_c('div',{staticClass:"pn-classname"},[_c('p',{staticClass:"pn-span1"},[_c('el-image',{staticClass:"span1-img",attrs:{"src":list.d_gc_image}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('img',{staticClass:"span1-img",attrs:{"src":_vm.imgUrlLittle}})])]),_vm._v(" "),_c('a',{attrs:{"href":_vm.CurrentEnvPrefix.search +
                                  '/?d_gc_id=' +
                                  list.d_gc_id}},[_vm._v(_vm._s(list.d_gc_name))])],1)]),_vm._v(" "),(list.cn_classs && list.cn_classs.length)?_c('div',{staticClass:"pn-second"},_vm._l((list.cn_classs),function(s){return _c('a',{key:s.d_gc_id,attrs:{"href":_vm.CurrentEnvPrefix.search +
                                '/?d_gc_id=' +
                                s.d_gc_id}},[_vm._v(_vm._s(s.d_gc_name))])}),0):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshow1 == index),expression:"isshow1 == index"}],staticClass:"pn-subclass"},[_c('div',{staticClass:"pn-subclass-main"},[_c('div',{staticClass:"pn-subclass-content"},[(_vm.hasThirdChild(list))?_c('ul',{staticClass:"pn-sc-list"},_vm._l((list.children),function(slist){return _c('li',{key:slist.d_gc_id,staticClass:"pn-sc-item"},[_c('a',{staticClass:"pn-scname1",attrs:{"href":_vm.CurrentEnvPrefix.search +
                                      '/?d_gc_id=' +
                                      slist.d_gc_id}},[_vm._v(_vm._s(slist.d_gc_name))]),_vm._v(" "),_c('ul',{staticClass:"pn-sc-ul"},_vm._l((slist.children),function(sclass){return _c('li',{key:sclass.d_gc_id,staticClass:"pn-sc-li"},[_c('a',{attrs:{"href":_vm.CurrentEnvPrefix.search +
                                          '/?d_gc_id=' +
                                          sclass.d_gc_id}},[_vm._v(_vm._s(sclass.d_gc_name))])])}),0)])}),0):_c('ul',{staticClass:"pn-sc-ul"},_vm._l((list.children),function(slist){return _c('li',{key:slist.d_gc_id,staticClass:"pn-sc-li"},[_c('a',{attrs:{"href":_vm.CurrentEnvPrefix.search +
                                      '/?d_gc_id=' +
                                      slist.d_gc_id}},[_vm._v(_vm._s(slist.d_gc_name))])])}),0)])])])])}),0)])])])])])])])}
var publicnav_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fa fa-list",attrs:{"aria-hidden":"true"}})])}]
var publicnav_esExports = { render: publicnav_render, staticRenderFns: publicnav_staticRenderFns }
/* harmony default export */ var public_publicnav = (publicnav_esExports);
// CONCATENATED MODULE: ./src/components/public/publicnav.vue
function publicnav_injectStyle (ssrContext) {
  __webpack_require__("W13x")
}
var publicnav_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var publicnav___vue_template_functional__ = false
/* styles */
var publicnav___vue_styles__ = publicnav_injectStyle
/* scopeId */
var publicnav___vue_scopeId__ = "data-v-7020207c"
/* moduleIdentifier (server only) */
var publicnav___vue_module_identifier__ = null
var publicnav_Component = publicnav_normalizeComponent(
  publicnav,
  public_publicnav,
  publicnav___vue_template_functional__,
  publicnav___vue_styles__,
  publicnav___vue_scopeId__,
  publicnav___vue_module_identifier__
)


/* harmony default export */ var components_public_publicnav = (publicnav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/public/publicnav1.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import './global/css/font-awesome/css/font-awesome.min.css'
// import VueAwesomeSwiper from 'vue-awesome-swiper'




/* harmony default export */ var publicnav1 = ({
  data: function data() {
    return {
      CurrentEnvPrefix: urlprefix["a" /* CurrentEnvPrefix */],
      isshow: false,
      isshow1: -1,
      classlist: [],
      shoplist: [],
      searchnavlist: [],
      swiperOption: {
        autoplay: true,
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
        mousewheelControl: true
      }
    };
  },

  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"]
  },
  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },

  methods: {
    showcategory: function showcategory() {
      this.isshow = true;
    },
    hiddencategory: function hiddencategory() {
      this.isshow = false;
    },
    showsubclass: function showsubclass(index) {
      this.isshow1 = index;
    },
    hiddensubclass: function hiddensubclass(index) {
      this.isshow1 = -1;
    },
    getClassList: function getClassList() {
      var _this = this;

      this.$Api.get({ api: this.Common.getSourec().plapi + "/goods_search/nav_list" }).then(function (response) {
        if (response.data.ResponseStatus == 0) {
          _this.classlist = response.data.datas.cates;
        }
      });
    },
    hrefClick: function hrefClick(href) {
      this.$HrefRouter.WebHrefRrouter(href);
    },
    getNavShop: function getNavShop() {
      var _this2 = this;

      this.$Api.get({ api: "/ad/newshop/list" }).then(function (response) {
        _this2.shoplist = response.data.datas;
      });
    },
    getNavMenu: function getNavMenu() {
      var _this3 = this;

      this.$Api.get({
        api: this.Common.getSourec().plapi + "/goods_search/search_nav"
      }).then(function (response) {
        if (response.data.ResponseStatus == 0) {
          _this3.searchnavlist = response.data.datas;
        }
      });
    }
  },
  mounted: function mounted() {
    this.getClassList();
    this.getNavShop();
    this.getNavMenu();
    var path = this.$route.path;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c8c43c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/publicnav1.vue
var publicnav1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"ng-nav main-color-border"},[_c('div',{staticClass:"w1200"},[_c('div',{staticClass:"ng-all-category",on:{"mouseleave":function($event){return _vm.hiddencategory()}}},[_c('div',{staticClass:"ng-ac-title",on:{"mouseenter":function($event){return _vm.showcategory()}}},[_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshow),expression:"isshow"}],staticStyle:{"width":"1200px","position":"absolute","padding-top":"15px"}},[_c('div',{staticClass:"pn-category"},[_c('div',{staticClass:"pn-category-menu"},[_c('ul',{staticClass:"pn-menu"},_vm._l((_vm.classlist),function(list,index){return _c('li',{key:index,staticClass:"pn-menulist",on:{"mouseenter":function($event){return _vm.showsubclass(index)},"mouseleave":function($event){return _vm.hiddensubclass(index)}}},[_c('div',{staticClass:"pn-class"},[_c('div',{staticClass:"pn-classname"},[_c('p',{staticClass:"pn-span1"},[_c('a',{attrs:{"href":_vm.CurrentEnvPrefix.main +
                                _vm.Common.getSourec().sitehost +
                                '/index.php?act=search&op=index&cate_id=' +
                                list.gc_id}},[_vm._v(_vm._s(list.gc_name))])]),_vm._v(" "),(list.cn_classes.length > 0)?_c('div',{staticClass:"pn-span2"},_vm._l((list.cn_classes),function(slist,jindex){return _c('a',{key:jindex,attrs:{"href":_vm.CurrentEnvPrefix.main +
                                _vm.Common.getSourec().sitehost +
                                '/index.php?act=search&op=index&cate_id=' +
                                slist.gc_id}},[_vm._v(_vm._s(slist.gc_name)+"\n                          ")])}),0):_c('div',{staticClass:"pn-span2"},[(index < 2)?_vm._l((list.children),function(slist,kindex){return _c('a',{key:kindex,attrs:{"href":_vm.CurrentEnvPrefix.main +
                                  _vm.Common.getSourec().sitehost +
                                  '/index.php?act=search&op=index&cate_id=' +
                                  slist.gc_id}},[_vm._v(_vm._s(slist.gc_name)+"\n                            ")])}):_vm._e()],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isshow1 == index),expression:"isshow1 == index"}],staticClass:"pn-subclass"},[_c('div',{staticClass:"pn-subclass-main"},[_c('div',{staticClass:"pn-subclass-content"},[_c('ul',{staticClass:"pn-sc-list"},_vm._l((list.children),function(slist,index){return _c('li',{key:index,staticClass:"pn-sc-item"},[_c('a',{staticClass:"pn-scname1",attrs:{"href":_vm.CurrentEnvPrefix.main +
                                    _vm.Common.getSourec().sitehost +
                                    '/index.php?act=search&op=index&cate_id=' +
                                    slist.gc_id}},[_vm._v(_vm._s(slist.gc_name))]),_vm._v(" "),_c('ul',{staticClass:"pn-sc-ul"},_vm._l((slist.children),function(sclass){return _c('li',{key:sclass.gc_id,staticClass:"pn-sc-li"},[_c('a',{attrs:{"href":_vm.CurrentEnvPrefix.main +
                                        _vm.Common.getSourec().sitehost +
                                        '/index.php?act=search&op=index&cate_id=' +
                                        sclass.gc_id}},[_vm._v(_vm._s(sclass.gc_name))])])}),0)])}),0)])])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"pn-store"},[_c('div',{staticClass:"pn-storelist"},[_c('swiper',{ref:"mySwiper",staticStyle:{"height":"235px"},attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.shoplist),function(list,index){return _c('swiper-slide',{key:index},[_c('a',{attrs:{"href":list.ads[0].url,"target":"_blank"}},[_c('img',{attrs:{"src":list.ads[0].pic}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","margin-top":"10px"}},[_vm._v("\n                          "+_vm._s(list.store_name)+"\n                        ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"border":"1px solid #FF3838","color":"#ff3838","width":"82px","height":"20px","display":"inline-block","text-align":"center","line-height":"20px","border-radius":"12px"}},[_vm._v("新进商家")])])])])}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",staticStyle:{"bottom":"0"},attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)])])])]),_vm._v(" "),_c('ul',{staticClass:"site-menu"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.hrefClick(_vm.CurrentEnvPrefix.main + _vm.Common.getSourec().sitehost)}}},[_vm._v("首页")])]),_vm._v(" "),_vm._l((_vm.searchnavlist),function(list,index){return _c('li',[_c('a',{ref:"cxxp",refInFor:true,attrs:{"href":list.nav_url,"target":"_blank"}},[_vm._v(_vm._s(list.nav_title)),_c('img',{attrs:{"src":list.nav_image}})])])})],2)])])])}
var publicnav1_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"fa fa-list",attrs:{"aria-hidden":"true"}})])}]
var publicnav1_esExports = { render: publicnav1_render, staticRenderFns: publicnav1_staticRenderFns }
/* harmony default export */ var public_publicnav1 = (publicnav1_esExports);
// CONCATENATED MODULE: ./src/components/public/publicnav1.vue
function publicnav1_injectStyle (ssrContext) {
  __webpack_require__("QflI")
}
var publicnav1_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var publicnav1___vue_template_functional__ = false
/* styles */
var publicnav1___vue_styles__ = publicnav1_injectStyle
/* scopeId */
var publicnav1___vue_scopeId__ = "data-v-1c8c43c0"
/* moduleIdentifier (server only) */
var publicnav1___vue_module_identifier__ = null
var publicnav1_Component = publicnav1_normalizeComponent(
  publicnav1,
  public_publicnav1,
  publicnav1___vue_template_functional__,
  publicnav1___vue_styles__,
  publicnav1___vue_scopeId__,
  publicnav1___vue_module_identifier__
)

/* harmony default export */ var components_public_publicnav1 = (publicnav1_Component.exports);

// EXTERNAL MODULE: ./src/global/js/htmldecode.js
var htmldecode = __webpack_require__("O55x");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/public/footer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var footer = ({
  data: function data() {
    return {
      setsearch: [],
      CurrentEnvPrefix: urlprefix["a" /* CurrentEnvPrefix */]
    };
  },

  methods: {
    getSetSearch: function getSetSearch() {
      var _this = this;
      setTimeout(function () {
        var site = _this.Common.getSourec().site;
        var set = [];
        if (site) {
          set.code = htmldecode["a" /* default */].htmlDecode(site.statistics_code.value);
          set.email = site.site_email.value;
          set.phone = site.site_phone.value;
          set.logowx = site.site_logowx.value;
        }
        _this.setsearch = set;
      }, 500);
    }
  },
  mounted: function mounted() {
    this.getSetSearch();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f86c7f5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ng-faq"},[_c('div',{staticClass:"w1100"},[_c('ul',{staticClass:"ng-help-ul"},[_c('li',{staticClass:"ng-help-li"},[_c('span',{staticClass:"ng-help-span"},[_vm._v("新手入门")]),_vm._v(" "),_c('ul',{staticClass:"ng-help-list"},[_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php"),"target":"_blank'"}},[_vm._v("登录注册")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=797"),"target":"_blank"}},[_vm._v("支付方式")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=795"),"target":"_blank"}},[_vm._v("新手下单流程")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=1595"),"target":"_blank"}},[_vm._v("关于我们")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=1593"),"target":"_blank"}},[_vm._v("联系我们")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=1591"),"target":"_blank"}},[_vm._v("招聘英才")])])])]),_vm._v(" "),_c('li',{staticClass:"ng-help-li"},[_c('span',{staticClass:"ng-help-span"},[_vm._v("店主之家")]),_vm._v(" "),_c('ul',{staticClass:"ng-help-list"},[_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=11"),"target":"_blank"}},[_vm._v("如何管理店铺")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=671"),"target":"_blank"}},[_vm._v("QQ无法跳转")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=813"),"target":"_blank"}},[_vm._v("电商城最\"惠\"招商")])])])]),_vm._v(" "),_c('li',{staticClass:"ng-help-li"},[_c('span',{staticClass:"ng-help-span"},[_vm._v("售后服务")]),_vm._v(" "),_c('ul',{staticClass:"ng-help-list"},[_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=809"),"target":"_blank"}},[_vm._v("快递查询")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=26"),"target":"_blank"}},[_vm._v("联系卖家")])])])]),_vm._v(" "),_c('li',{staticClass:"ng-help-li"},[_c('span',{staticClass:"ng-help-span"},[_vm._v("特色功能")]),_vm._v(" "),_c('ul',{staticClass:"ng-help-list"},[_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=469"),"target":"_blank"}},[_vm._v("APP使用手册")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=803"),"target":"_blank"}},[_vm._v("微商神器")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=1367"),"target":"_blank"}},[_vm._v("纺支宝代发说明")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":("" + (_vm.CurrentEnvPrefix.main) + (_vm.Common.getSourec().sitehost) + "/shop/index.php?act=article&op=show&article_id=1033"),"target":"_blank"}},[_vm._v("如何一键上传")])])])])]),_vm._v(" "),_c('div',{staticClass:"ng-help"},[_c('div',{staticClass:"contact-border"},[_c('p',{staticClass:"help-tel"},[_vm._v(_vm._s(_vm.setsearch.phone))]),_vm._v(" "),_c('p',{staticClass:"help-mail"},[_vm._v(_vm._s(_vm.setsearch.email))])])])])]),_vm._v(" "),_c('div',{staticClass:"ng-footer"},[_c('div',{staticClass:"w1200"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.setsearch.code)}},[_vm._v(_vm._s(_vm.setsearch.code))]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p')])])])}
var footer_staticRenderFns = []
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var public_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/public/footer.vue
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = null
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  public_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var components_public_footer = (footer_Component.exports);

// EXTERNAL MODULE: ./node_modules/echarts/index.js
var echarts = __webpack_require__("XLwt");
var echarts_default = /*#__PURE__*/__webpack_require__.n(echarts);

// EXTERNAL MODULE: ./node_modules/url/url.js
var url_url = __webpack_require__("UZ5h");
var url_default = /*#__PURE__*/__webpack_require__.n(url_url);

// EXTERNAL MODULE: ./node_modules/querystring-es3/index.js
var querystring_es3 = __webpack_require__("1nuA");
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);

// EXTERNAL MODULE: ./config/appsetting.js
var appsetting = __webpack_require__("9F4c");
var appsetting_default = /*#__PURE__*/__webpack_require__.n(appsetting);

// CONCATENATED MODULE: ./src/global/js/mob_router.js








var appcontrollers = {
	// 这个是调用页面的方法 apphref://functionController/searchbyimage?param_gcid=fadfa
	APP_FUNC: { ios: 'functionController', android: 'functionActivity', wxapp: 'functionController', wap: 'functionController' },
	// 对应页面: h5
	APP_H5: { ios: 'html5WebViewController', android: 'H5Activity', wxapp: '/pages/webview/webview', wap: 'common/h5' },
	// 对应页面: 登录
	APP_LOGIN: { ios: 'NewLoginController', android: 'LoginActivity', wxapp: '/pages/login-register/login/login', wap: '/common/singon' },
	// 对应页面: 注册
	APP_REGISTER: { ios: 'RegisterController', android: 'RegisterActivity', wxapp: '/pages/login-register/forget/forgetpassword', wap: '/common/singin' },
	// 对应页面: 安全验证
	APP_SAFETY_CHECK: { ios: 'RegisterController', android: 'SafetyCheckActivity', wxapp: '', wap: '/common/safety' },
	// 对应页面: 绑定手机
	APP_BIND_PHONE: { ios: 'RegisterController', android: 'BindPhoneActivity', wxapp: '/pages/login-register/forget/forgetpassword', wap: '/common/bindphone' },
	// 对应页面: 找回登录密码
	APP_FORGET_PASSWORD: { ios: 'RegisterController', android: 'UpdatePasswordActivity', wxapp: '/pages/login-register/register/register', wap: '/common/findpassword' },
	// 对应页面: 找回支付密码
	APP_FORGET_PAY_PASSWORD: { ios: 'RegisterController', android: 'UpdatePayPasswordActivity', wxapp: '/pages/login-register/register/register', wap: '/common/paypassword' },
	// 对应页面: 商家列表
	APP_STORES: { ios: 'VenderListController', android: 'VenderActivity', wxapp: '/pages/vender/vender', wap: '/commodity' },
	// 对应页面：商家APP首页
	APP_STORE_TAB_INDEX: { ios: 'HomeStoreController', android: 'StoreHomeActivity', wxapp: '', wap: '/' },
	// 对应页面：店铺首页
	APP_STORE_INDEX: { ios: 'ShopHomeController', android: 'StoreDetailActivity', wxapp: '/pages/store/storeindex', wap: '/common/storehome' },
	// 对应页面：商城分类
	APP_GOODS_CLASS: { ios: 'GoodsClassViewController', android: 'GoodsClassActivity', wxapp: '/pages/searchGoods/search', wap: '/findgoods' },
	// 对应页面：店铺分类
	APP_STORE_CLASS: { ios: 'StoreClassController', android: 'StoreClassActivity', wxapp: '/pages/store/category/category', wap: '/common/subclass' },
	// 对应页面：购物车
	APP_CART: { ios: 'ShoppingCartController', android: 'CartActivity', wxapp: '/pages/cartlists/cartlist', wap: '/shoppingcate' },
	// 对应页面：商品列表
	APP_GOODS_LIST: { ios: 'GoodsListController', android: 'GoodsListActivity', wxapp: '/pages/goodslist/goodslist', wap: '/common/goodslist' },
	// 对应页面：商品详情
	APP_GOODS_DETAIL: { ios: 'GoodDetailController', android: 'GoodsDetailActivity', wxapp: '/pages/goodsdetail/goodsdetail', wap: '/common/goodsdetails/goodsdetail' },
	// 对应页面：个人中心
	APP_USER_CENTER: { ios: 'AccountSettingController', android: 'AccountActivity', wxapp: '/pages/usercenter/accountsetting/accountsetting', wap: '/accountsetting' },
	// 对应页面：个人中心 -> 订单列表
	APP_ORDER_LIST: { ios: 'OrderListController', android: 'OrderListActivity', wxapp: '/pages/usercenter/orderlist/orderlist', wap: '/common/order' },
	// 对应页面：个人中心 -> 订单详情
	APP_ORDER_DETAIL: { ios: 'OrderDetailController', android: 'OrderDetailActivity', wxapp: '/pages/usercenter/orderdetail/orderdetail', wap: '/common/orderdetailsdone' },
	// 对应页面：个人中心 -> 退款
	APP_REFUND: { ios: 'OrderRefundController', android: 'RefundableActivity', wxapp: '/pages/usercenter/orderrefund/orderrefund', wap: '/common/refundmoney' },
	// 对应页面：个人中心 -> 退款记录列表
	APP_REFUND_LIST: { ios: 'OrderRefundListController', android: 'RefundListActivity', wxapp: '/pages/usercenter/orderrefundlist/orderrefundlist', wap: '/common/refundlist' },
	// 对应页面：个人中心 -> 退款记录详情
	APP_REFUND_DETAIL: { ios: 'OrderRefundDetailController', android: 'RefundDetailActivity', wxapp: '/pages/usercenter/orderrefunddetail/orderrefunddetail', wap: '/common/refund' },
	// 对应页面：个人中心 -> 地址列表
	APP_ADDRESS_LIST: { ios: 'AddressListController', android: 'AddressListActivity', wxapp: '/pages/usercenter/addressctrl/addressctrl', wap: '/common/address' },
	// 对应页面：个人中心 -> 地址编辑
	APP_ADDRESS_EDIT: { ios: 'AddressEditController', android: 'AddressEditActivity', wxapp: '/pages/usercenter/editaddress/editaddress', wap: '/common/changeaddress' },
	// 对应页面：个人中心 -> 收藏商品
	APP_Favorite_GoodsList: { ios: 'FavoritesController', android: 'FavoriteListActivity', wxapp: '/pages/usercenter/collect/collect', wap: '/common/collection' },
	// 对应页面：个人中心 -> 关注店铺列表
	APP_Favorite_StoreList: { ios: 'AttentionController', android: 'FavoriteListActivity', wxapp: '/pages/usercenter/attention/attention', wap: '/common/follow' },
	// 对应页面：个人中心 -> 我的优惠券，代金券
	APP_Voucher_List: { ios: 'CouponController', android: 'CouponListActivity', wxapp: '', wap: '/common/mycoupons' },
	// 对应页面：个人中心 -> 浏览历史
	APP_History_List: { ios: 'HistoryController', android: 'BrowseListActivity', wxapp: '/pages/usercenter/scan/scan', wap: '/common/footprint' },
	// 对应页面：个人中心 -> 我的评价列表
	APP_Comment_List: { ios: 'DiscussController', android: 'MyCommentListActivity', wxapp: '/pages/usercenter/discuss/discuss', wap: '/common/myevaluate' },
	// 对应页面：个人中心 -> 我的平台客户咨询列表
	APP_MyConsult_List: { ios: 'MyConsultController', android: 'MallConsultActivity', wxapp: '/pages/usercenter/consult/consult', wap: '/common/consult' },
	// 对应页面：个人中心 -> 我的红包列表
	APP_Redpack_List: { ios: 'RedPackController', android: 'RedPacketListActivity', wxapp: '/pages/usercenter/redPack/redPack', wap: '/common/redpacket' },
	// 对应页面：个人中心 -> 消息总列表
	APP_NEWS_ALLList: { ios: 'AllNewsController', android: 'MessageActivity', wxapp: '/pages/usercenter/allNews/allnews', wap: '/common/mynews' },
	// 对应页面：个人中心 -> 我的账单
	APP_Bill_List: { ios: 'BillController', android: 'BillActivity', wxapp: '/pages/usercenter/billList/billlist', wap: '/common/balance' },
	// 对应页面：个人中心 -> 充值卡，账户 充值记录
	APP_PdRecharge_List: { ios: 'PdRechargeController', android: 'RechargeActivity', wxapp: '/pages/usercenter/PdRecharge/PdRecharge', wap: '/common/predeposit' },
	// 对应页面: 麦田代发
	APP_DAIFAI: { ios: 'MaitianAgencyController', android: 'DaiFaActivity', wxapp: '/pages/daifa/agencydaifa/agencydaifa', wap: '' },
	//文章主页
	APP_ATICLE_HOME: { ios: 'ArticlesHomeController', android: 'ArticleHomeActivity', wxapp: '', wap: '/common/articlelist' },
	//文章搜索列表
	APP_ATICLE_LIST: { ios: 'ArticleSearchListController', android: 'ArticleListActivity', wxapp: '', wap: '/common/articlesearch' },
	//文章详情
	APP_ATICLE_DETAIL: { ios: 'ArticleDetailViewController', android: 'ArticleDetailActivity', wxapp: '', wap: '/common/articledetail' }

	/* 	window.location.href
  *	@hrefpagetype : 跳转到app原生页面信息 (类型hrefPage)，可为空
  *  @shref : h5目标页面
  *  @appParams : app页面所需参数
  */
	// function hrefLocation(hrefpagetype, shref, appParams) {
	// 	var apppage;
	//   	// var isweixin = function(){ var ua = navigator.userAgent.toLowerCase(); return ua.match(/MicroMessenger/i) == "micromessenger" }
	//     if ( appversion>3.0 ) {
	//       var $url = shref;
	//       var strQuert = "";
	//       var params = querystring.parse(strQuert);
	//       if (params && params.act) {
	//         switch (params.act) {
	//             case 'goods':
	//                 $url = 'http://www.fangzhibao.com/wap/tmpl/product_detail.html?1=1' + strQuert;
	//             break;
	//             case 'ads':
	//                 $url = 'http://www.fangzhibao.com/wap/tmpl/ads_list.html';
	//             break;
	//             case 'store_list':
	//                 $url = 'http://www.fangzhibao.com/wap/shop.html?1=1&' + strQuert;
	//             break;
	//             case 'search':
	//                 $url = 'http://www.fangzhibao.com/wap/tmpl/product_list.html?1=1' + strQuert;
	//             break;
	//             case 'show_store':
	//                 if (params.op == 'store_article') {
	//                   $url = 'http://www.fangzhibao.com/wap/tmpl/article_show.html?1=1' + strQuert;
	//                 }
	//                 else if(params.op == 'show_article'){
	//                   $url = 'http://www.fangzhibao.com/wap/tmpl/article_show.html?1=1' + strQuert;
	//                 }
	//                 else if(params.op == 'goods_all' || params.op == 'goods_all_list'){
	//                   $url = 'http://www.fangzhibao.com/wap/tmpl/product_goods.html?1=1' + strQuert;
	//                 }
	//                 else {
	//                   $url = 'http://www.fangzhibao.com/wap/tmpl/product_store.html?1=1&store_id=' + params.store_id;
	//                 }
	//             break;
	//         }
	//       }

	//       var wta = { product_store: 'storeIndex', product_detail: 'goodsDetail', product_list:'goodsList', product_goods:'goodsList' }
	//       for(var k in wta){
	//         if ( $url && $url.indexOf( k + '.html' ) > -1 ){
	//             var wapquery = querystring.parse(strQuert);
	//             hrefpagetype = hrefPage[ wta[k] ];

	//             if (k == 'product_store') { appParams = { param_storeid: wapquery.store_id } }
	//             else if(k == 'product_detail'){ appParams = { param_goodsid: wapquery.goods_id } }
	//             else if(k == 'product_goods' || k == 'product_list'){
	//                 if (wapquery.gc_id) appParams = { param_gcid: wapquery.gc_id }; //apinfo.query += '&param_stcid=' + wapquery.stc_id;
	//                 if (wapquery.stc_id) appParams = { param_stcid: wapquery.stc_id }; //apinfo.query += '&param_stcid=' + wapquery.stc_id;
	//                 if (wapquery.store_id) appParams = { param_storeid: wapquery.store_id }; //apinfo.query += '&param_storeid=' + wapquery.store_id;
	//                 if (wapquery.keyword) appParams = { param_keyword: encodeURIComponent(wapquery.keyword || wapquery.inkeyword) }; //apinfo.query += '&param_keyword=' + encodeURIComponent(wapquery.keyword || wapquery.inkeyword); 

	//                 //添加筛选条件
	//                 if (wapquery.params_filters) {
	//                   appParams.params_filters = wapquery.params_filters
	//                 }
	//             }
	//         }
	//       }
	//     }

	// 	if (sfrom.toLowerCase() === fromWhere.ios) {
	// 		apppage = hrefpagetype.ios ? hrefpagetype.ios : hrefpagetype;
	//   		var _href = encodeURIComponent("apphref://"+apppage+"/app?zresource=m&"+$.param(appParams));
	// 		window.location.href = _href;
	// 	}
	// 	else {
	//   		apppage = hrefpagetype.android ? hrefpagetype.android : hrefpagetype;
	// 		if (window.control && apppage) {
	// 			window.control.pushpage(apppage , $.param(appParams));
	// 		}
	//       	else if(shref){ window.location.href = shref; }
	// 	}
	// }

};var HrefRouter = {
	// 格式化参数，加上统一参数
	_mob_toquery: function _mob_toquery(urlparams) {
		var squery = '';
		if (lodash_default.a.isString(urlparams)) {
			squery = urlparams;
		} else if (lodash_default.a.isObject(urlparams)) {
			lodash_default.a.map(urlparams, function (v, k) {
				squery += '&' + k + '=' + encodeURIComponent(v);
			});
		}
		squery += squery.indexOf('key') > 0 ? '' : '&key=' + memberinfo.getMemberInfo().key;
		// squery += squery.indexOf('isfrom')>0 ? '':'&isfrom=a';
		return squery;
	},
	// 根据服务器的的href来解析跳转
	_mob_pushRouter: function _mob_pushRouter(ctrl, href, func) {
		if (href.length == 0) {
			return;
		}

		var _url = url_default.a.parse(href);
		var ourl_params = querystring_es3_default.a.parse(_url.query);
		/*	如果过来的URL请求的是本地方法
   *	请求方式：functionController?zresource=n&params_func=functionTel&params_phone=400-101-1700 */
		if (_url.pathname == 'functionController') {
			switch (ourl_params.params_func) {
				case 'functionTel':
					{
						var tel = ourl_params.params_phone;
						window.location.href = 'tel://' + tel;
						return;
					}
					break;
				default:
					typeof func == 'function' && func(ourl_params);return;
					break;
			}
		} else if (ourl_params.phtml5url) {
			var _ph5url = ourl_params.phtml5url;delete ourl_params.phtml5url;
			_ph5url += _ph5url.indexOf('?') > 0 ? '' : '?zresource=m';
			window.location.href = _ph5url + this._mob_toquery(ourl_params);
		} else {
			var okctrl; //找到了的终端页面对像
			var keysForAppCtrl = keys_default()(appcontrollers);
			// 寻找对应Path，并跳转到指定终端页面
			for (var i = 0; i < lodash_default.a.size(keysForAppCtrl); i++) {
				var _k = keysForAppCtrl[i];
				var appctrl = appcontrollers[_k];
				if (appctrl.wap == _url.pathname) {
					okctrl = appctrl;
					break;
				}
			}
			if (!okctrl) {
				// 如果没有找到okctrl，被视为本地跳转，这时候要嫁接到APP上去 
				okctrl = appcontrollers.APP_H5;
				ourl_params.phtml5url = (_url.host || window.location.origin) + _url.pathname;
				if (ourl_params.title) ourl_params.ptitle = ourl_params.title;
				if (ourl_params.url) ourl_params.phtml5url = ourl_params.url;
				delete ourl_params.title;
				delete ourl_params.url;
			}
			if (okctrl) {
				if (common.getSourec().isFromApp && common.getSourec().isIos) {
					window.location.href = encodeURIComponent('apphref://' + okctrl.ios + '?zresource=n' + this._mob_toquery(ourl_params));
				} else if (common.getSourec().isFromApp && common.getSourec().isAndroid) {
					window.control.pushpage('apphref://' + okctrl.android + '?zresource=n' + this._mob_toquery(ourl_params));
				} else {
					// ctrl.$router.push({path: href});
					window.location.href = href;
				}
				return;
			}

			if (href.indexOf('http') != -1) {
				window.location.href = href;
				return;
			}
		}
	},
	WebHrefRrouter: function WebHrefRrouter(href) {
		window.location.href = href;
		// ctrl.$router.push({path:href,param:{a:1}});
	}
};

/* harmony default export */ var mob_router = (HrefRouter);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tianmao/identify.vue
//
//
//
//
//

/* harmony default export */ var identify = ({
  name: 'SIdentify',
  props: {
    identifyCode: {
      type: String,
      default: '1234'
    },
    fontSizeMin: {
      type: Number,
      default: 16
    },
    fontSizeMax: {
      type: Number,
      default: 40
    },
    backgroundColorMin: {
      type: Number,
      default: 180
    },
    backgroundColorMax: {
      type: Number,
      default: 240
    },
    colorMin: {
      type: Number,
      default: 50
    },
    colorMax: {
      type: Number,
      default: 160
    },
    lineColorMin: {
      type: Number,
      default: 40
    },
    lineColorMax: {
      type: Number,
      default: 180
    },
    dotColorMin: {
      type: Number,
      default: 0
    },
    dotColorMax: {
      type: Number,
      default: 255
    },
    contentWidth: {
      type: Number,
      default: 112
    },
    contentHeight: {
      type: Number,
      default: 38
    }
  },
  methods: {
    // 生成一个随机数
    randomNum: function randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    // 生成一个随机的颜色
    randomColor: function randomColor(min, max) {
      var r = this.randomNum(min, max);
      var g = this.randomNum(min, max);
      var b = this.randomNum(min, max);
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    },
    drawPic: function drawPic() {
      var canvas = document.getElementById('s-canvas');
      var ctx = canvas.getContext('2d');
      ctx.textBaseline = 'bottom';
      // 绘制背景
      ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax);
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);
      // 绘制文字
      for (var i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i);
      }
      this.drawLine(ctx);
      this.drawDot(ctx);
    },
    drawText: function drawText(ctx, txt, i) {
      ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax);
      ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei';
      var x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1));
      var y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
      var deg = this.randomNum(-45, 45);
      // 修改坐标原点和旋转角度
      ctx.translate(x, y);
      ctx.rotate(deg * Math.PI / 180);
      ctx.fillText(txt, 0, 0);
      // 恢复坐标原点和旋转角度
      ctx.rotate(-deg * Math.PI / 180);
      ctx.translate(-x, -y);
    },
    drawLine: function drawLine(ctx) {
      // 绘制干扰线
      for (var i = 0; i < 8; i++) {
        ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax);
        ctx.beginPath();
        ctx.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctx.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight));
        ctx.stroke();
      }
    },
    drawDot: function drawDot(ctx) {
      // 绘制干扰点
      for (var i = 0; i < 100; i++) {
        ctx.fillStyle = this.randomColor(0, 255);
        ctx.beginPath();
        ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI);
        ctx.fill();
      }
    }
  },
  watch: {
    identifyCode: function identifyCode() {
      this.drawPic();
    }
  },
  mounted: function mounted() {
    this.drawPic();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-575a8db5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tianmao/identify.vue
var identify_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-canvas"},[_c('canvas',{attrs:{"id":"s-canvas","width":_vm.contentWidth,"height":_vm.contentHeight}})])}
var identify_staticRenderFns = []
var identify_esExports = { render: identify_render, staticRenderFns: identify_staticRenderFns }
/* harmony default export */ var tianmao_identify = (identify_esExports);
// CONCATENATED MODULE: ./src/components/tianmao/identify.vue
var identify_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var identify___vue_template_functional__ = false
/* styles */
var identify___vue_styles__ = null
/* scopeId */
var identify___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var identify___vue_module_identifier__ = null
var identify_Component = identify_normalizeComponent(
  identify,
  tianmao_identify,
  identify___vue_template_functional__,
  identify___vue_styles__,
  identify___vue_scopeId__,
  identify___vue_module_identifier__
)

/* harmony default export */ var components_tianmao_identify = (identify_Component.exports);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./static/theme-#FF2D51/index.css
var theme__FF2D51 = __webpack_require__("N1Qb");
var theme__FF2D51_default = /*#__PURE__*/__webpack_require__.n(theme__FF2D51);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/global/js/adv.js


var adv_api = new api_API();
var UrlParamHash = function UrlParamHash(url) {
	var params = [],
	    h;
	if (url) {
		var hash = url.slice(url.indexOf("?") + 1).split('&');
		for (var i = 0; i < hash.length; i++) {
			h = hash[i].split("=");
			params[h[0]] = h[1];
		}
	}
	return params;
};

var adv = {

	bpeventadv: function bpeventadv(val, url) {
		var params = UrlParamHash(url);
		var goods_id = params['goods_id'] ? decodeURI(params['goods_id']) : '';
		var store_id = params['store_id'] ? decodeURI(params['store_id']) : '';
		if (goods_id) {
			val.goods_id = goods_id;
			val.direct_type = '商品详情';
		} else if (store_id) {
			val.store_id = store_id;
			val.direct_type = '店铺';
		} else {
			val.direct_type = '其他';
		}
		console.log(val);
		adv_api.post({ api: common.getSourec().extapi + '/tracking/addBpLog', param: { 'evt_name': '广告点击率统计', 'extInfo': val } }).then(function (response) {});
	}
};

/* harmony default export */ var js_adv = (adv);
// EXTERNAL MODULE: ./node_modules/vue-meta/dist/vue-meta.esm.js
var vue_meta_esm = __webpack_require__("f3bp");

// CONCATENATED MODULE: ./src/main.js







// import './global/css/main.css'






















// var SystemSiteId = cookie.get('SystemSiteId') ? cookie.get('SystemSiteId') : 1;
// if(SystemSiteId=='1'){
// 	console.log(SystemSiteId)
// 	require('./global/css/main.css')
// }else if(SystemSiteId=='2'){
// 	console.log(SystemSiteId)
// 	require('./global/css/childmain.css')
// }else if(SystemSiteId=='3'){
// 	console.log(SystemSiteId)
// 	require('./global/css/gzmain.css')
// }else{
// 	require('./global/css/main.css')
// }
vue_esm["default"].use(vue_meta_esm["a" /* default */]);
vue_esm["default"].use(components_tianmao_identify);
vue_esm["default"].component('s-identify', components_tianmao_identify);
vue_esm["default"].prototype.$Api = new api_API();
vue_esm["default"].prototype.$ZJF = new api_ZJF();
vue_esm["default"].prototype.MemberInfo = memberinfo;
vue_esm["default"].prototype.Helper = js_helper;
vue_esm["default"].prototype.Common = common;
vue_esm["default"].prototype.adv = js_adv;
vue_esm["default"].prototype.$HrefRouter = mob_router;
vue_esm["default"].prototype.moment = moment_default.a;
vue_esm["default"].prototype.$cookie = vue_cookie_default.a;
vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(ydui_rem_default.a);
vue_esm["default"].use(vue_clipboard_default.a);
vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].component('publictop', components_public_publictop);
vue_esm["default"].component('myheader', components_public_header);
vue_esm["default"].component('publicnav', components_public_publicnav);
vue_esm["default"].component('publicnav1', components_public_publicnav1);
vue_esm["default"].component('myfooter', components_public_footer);
/* eslint-disable no-new */

new vue_esm["default"]({
  el: '#app',
  router: router,
  components: { App: src_App },
  template: '<App/>'
});

/***/ }),

/***/ "O55x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var HtmlUtil = {
    /*1.用浏览器内部转换器实现html转码*/
    htmlEncode: function htmlEncode(html) {
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
        temp.textContent != undefined ? temp.textContent = html : temp.innerText = html;
        //3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
        var output = temp.innerHTML;
        temp = null;
        return output;
    },
    /*2.用浏览器内部转换器实现html解码*/
    htmlDecode: function htmlDecode(text) {
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
        temp.innerHTML = text;
        //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
    },
    /*3.用正则表达式实现html转码*/
    htmlEncodeByRegExp: function htmlEncodeByRegExp(str) {
        var s = "";
        if (str.length == 0) return "";
        s = str.replace(/&/g, "&amp;");
        s = s.replace(/</g, "&lt;");
        s = s.replace(/>/g, "&gt;");
        s = s.replace(/ /g, "&nbsp;");
        s = s.replace(/\'/g, "&#39;");
        s = s.replace(/\"/g, "&quot;");
        return s;
    },
    /*4.用正则表达式实现html解码*/
    htmlDecodeByRegExp: function htmlDecodeByRegExp(str) {
        var s = "";
        if (str.length == 0) return "";
        s = str.replace(/&amp;/g, "&");
        s = s.replace(/&lt;/g, "<");
        s = s.replace(/&gt;/g, ">");
        s = s.replace(/&nbsp;/g, " ");
        s = s.replace(/&#39;/g, "\'");
        s = s.replace(/&quot;/g, "\"");
        return s;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (HtmlUtil);

/***/ }),

/***/ "QflI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RbWE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W13x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fma8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA8CAYAAAA+CQlPAAAAAXNSR0IArs4c6QAABQ5JREFUaEPdm41xFTcQgHcrSFwBUAGmgoQKEioAKohdAaSCmAqACsAVABUAFSSuIE4Fy3yMziPklW6lu8s7P828GT9bf5/2Vz9WWbGY2c8i8ouInIrIryLCd34uy0cRuRaRLyLyUVU/rTiNUFcaqtWoZGb3ReQ3EXlWgYwO8V5E3qvq22iDJfWGwRPwiwS8ZA5lWzThQkReqSo/b1K6wTcE9hbgpaq+2oK8C9zM/hCRl8l25+aD3f6TPnldbB7bx0TuzXWS/MBzVcUfrFZC4MlpvRaR3xsjX2GjyU5xXrMlaQ994gjxE60C/JvZToMVZsHT5N41HBeSvVBVoIdLWtwzEeHzU6WjN6r6fHiQrGET3MxQyw8V1UbCZ0uBS4hsAXCcXlkFvgqeJP25Ak3IAXozr5sWHZPxpL8Y3gVPq46kveRjVVtrqW2aByZEUlQWwh1mMVRq4Nh06cj+43eqGnJcQ7OpNDIznNpT589PRk3tFriZsYp/OYM8PgT0NI8KPKb2SFUJm13lB/CGXZ+rKtnUQYuZoW2l2pPmPumdWAnuqdSlqrbid++Yw/WTzZPIlIlPt8rfgJsZSQQOLS+ErNMtvXfvKlTm+UVVH/X0lYN70v7fPHjPpM0MT19mel0+6Dt4su2/S2mrKvn07kplvl0mOYF7nnyX0p7x8g+iHn4CJ0PLk5WrvUo7A8fhkm/kJRx9tKI2b1WVE5VdFzMjfucePqzugHsr1x0eDrFCTlJzraonkbkAzsFCuRM62VMIq4GYGVrJOUFeyORmDy0AL7OhT6pKTN99STs4/FNeQtoKeOnY7gx4CsVWgP+pqmhxswBeNly03ZsbcO2/mxkblXzPPgwearg2wGh/jqmG5u9JPNRwdKJrt3PAQ6H4GMBXs/G7JvFh8LsczriY+Lcwn1DaiqqX29Huve3adhvtr7I3D21P73rmNpx1Au6dvISyn6hktqrnJF9fVdU7Er81hWlbWjqIUEjYCijSbzp/K+07nHxN4N5Rzq43KpUNSvjwZAL3tqa7DmtmxlFZfjTWdXiSHzaWOS/fOcrZ7H4sotJenYq0uwSVg3sesquzUZDedo606SJ83kblHJxkgKOc8nYytLHvnfxofTPjRoeXGXnpdsblTYp32sppBknBwVW+ouJcZt7vnZ93aQjow2JFF99Hj0p4atd4pBBKUcvxPXASgPI4h3YHg2/c14cTlllwKlRU6iDwgTc44didw7eegtQu4zEFUtruO+ledU/pNJcGON5W6Yafe/xTg8fRMdiil041kqTa05u66Hrx8uo8Wjny3KsGzxjs5Yn1qz0PMTOefJBTjFxYhv3QLHiyeS925osLOCt+GV3xvF6SMNe+LWDCFuZVRpxyyBB8CDzBk88j/drjO6phAiwCJoDHrd5omFn+vHvuxQULOt3l0f9i+DB4gkf9gPeeX7WEPb1prb1fr7VFyjzkvXl/k7QjAk8dnLCbeHWBZ8kEhxcsQOQR7oj2A4zWAH0renTAV7POIfBsAVBR0txeDWhJGOniL2ZT5Mb7t7x/F34ReLYAmACLwKd3Eb4mv4Bq8m8as8CFY2xFnanqLfhVwEvxpbyaxcjPv/g+qe1k85zodoF6qhKUPOOw2frucDcBHzHqpW0q29Wy2xv4owFPUcd7KODDL13pvbVvbLDyqV4elcQzZzsr+aMED2SaV0cLnuCJKt5/OZwfNXiWZpMUsQkiZ2ATc/ENsBxPe0WFZFoAAAAASUVORK5CYII="

/***/ }),

/***/ "l7hk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vQGE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static-fzb/js/app.99b96a7099afc25aade0.js